import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import * as XLSX from 'xlsx';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import {
  collection, getDocs, addDoc, doc, getDoc, setDoc, updateDoc, query, orderBy
} from 'firebase/firestore';
import {
  Box, Container, Typography, Paper, Button, TextField, IconButton,
  Chip, CircularProgress, InputAdornment, Dialog, DialogTitle,
  DialogContent, DialogActions, MenuItem, Avatar,
  ToggleButtonGroup, ToggleButton, Tooltip, Divider,
  Select, OutlinedInput, InputLabel, FormControl, Autocomplete,
  Popover, Checkbox, FormControlLabel,
  Menu, ListItemIcon, ListItemText, useMediaQuery,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { deptCode } from '../utils/depts';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LagbasLogo from '../components/LagbasLogo';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BusinessIcon from '@mui/icons-material/Business';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EventIcon from '@mui/icons-material/Event';
import FlagIcon from '@mui/icons-material/Flag';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import TableChartIcon from '@mui/icons-material/TableChart';
import TuneIcon from '@mui/icons-material/Tune';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import Hjalptext, { IkonKnapp } from '../components/Hjalptext';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { SWEDISH_MUNICIPALITIES } from '../utils/swedishMunicipalities';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Alert from '@mui/material/Alert';
import NyKundDialog from '../modules/crm/NyKundDialog';
import {
  COMPANY_STATUSES_LIST, parseBookingEmail, insertBullet, SEGMENT_OPTIONS, ORGANISATIONSTYP_OPTIONS, segmentColor,
} from '../modules/crm/kundformular';
import { exportVanligExcel } from '../utils/leadsExcelExport';
import { byggVanligaBlad } from '../modules/crm/vanligExport';
import { exportBildkalla } from '../modules/crm/bilder';
import ExportDialog from '../modules/crm/ExportDialog';
import { STAGES, stageInfo } from '../modules/crm/skeden';
import { KundprojektRad, KanbanKundprojekt } from '../modules/crm/KundprojektVyer';
import { laddaAllaKundprojekt, laddaKundprojekt, sparaKundprojektAndringar } from '../modules/crm/kundprojektData';
import KundprojektListvy from '../modules/crm/KundprojektListvy';
import { urvalKundprojekt } from '../modules/crm/kundprojektExport';
import { kundprojektSammanfattning, kpLeadPredikat, KP_LEADFILTER, medLead } from '../modules/crm/kundprojekt';
import {
  tratt, aktivitetPerPeriod, demosMatbara, tidigastePeriodStart,
  ekonomiRader, offerterPerLead as grupperaOfferter, normaliseraSkede, arAktiv,
  harFramtidaSteg, arForfallen, harForfallenUppfoljning, dagarISkede, dagarISkedeTon, lokalDatum,
  OFFERT_STATUSAR, uppfoljningStatusText,
} from '../modules/crm/pipelineFlode';
import {
  bytSkede, nyttLeadSkedesfalt, laddaAllaOfferter, laddaMoten, sattAterkontakt,
} from '../modules/crm/pipelineData';
import BokningsmailDialog from '../modules/crm/BokningsmailDialog';
import LeadslistaImportDialog from '../modules/crm/LeadslistaImportDialog';
import { SegmentEtikett } from '../modules/crm/KategoriVal';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { isFlatboxLead, flatboxOfferterPerLead, flatboxEtikett, kampanjForLead, kampanjText } from '../modules/crm/flatboxLead';
import { canUseFlatbox } from '../utils/permissions';
import { byggAnalysBlad } from '../modules/crm/analysExport';
import { laddaAnalysData, laddaKontakter } from '../modules/crm/analysExportData';
import { skrivAnalysExcel } from '../utils/analysExcel';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import {
  PipelineTratt, AktivitetRad, EkonomiVy, StorlekValjare, StorlekBokstav, AterkontaktBekraftelse,
} from '../modules/crm/PipelineVyer';


const OFFER_STATUSES = [
  { key: 'skapad',      label: 'Skapad',      color: '#E65100', bg: '#FFF3E0' },
  { key: 'skickad',     label: 'Skickad',     color: '#1565C0', bg: '#E3F2FD' },
  { key: 'uppföljd',    label: 'Uppföljd',    color: '#2E7D32', bg: '#E8F5E9' },
  { key: 'accepterad',  label: 'Accepterad',  color: '#6A1B9A', bg: '#F3E5F5' },
];

const DEMO_STATUSES = [
  { key: 'bokad',      label: 'Bokad',      color: '#00897B', bg: '#E0F2F1' },
  { key: 'genomförd',  label: 'Genomförd',  color: '#2E7D32', bg: '#E8F5E9' },
  // Kunden har avbokat och ny tid är inte satt än. Rött, som förfallen
  // uppföljning — det är samma sorts skuld: någon måste höra av sig.
  { key: 'avbokad',    label: 'Avbokad',    color: '#C62828', bg: '#FFEBEE' },
  // Kunden anslöt aldrig. Samma skuld som en avbokning — ny tid måste sättas —
  // men värd att skilja ut: en avbokning är ett besked, ett uteblivet möte är
  // en tyst signal om hur högt affären står på kundens lista.
  { key: 'utebliven', label: 'Kunden kom inte', color: '#AD1457', bg: '#FCE4EC' },
];

// Demo-statusar där mötet inte blev av och ny tid saknas. Leadet färgas i
// listan tills någon bokat om.
export const DEMO_NEEDS_REBOOKING = ['avbokad', 'utebliven'];


const BASE_TYPES = [
  { key: 'konsult',     label: 'Konsulttjänst' },
  { key: 'produkt',     label: 'Produkt' },
  { key: 'kombination', label: 'Kombination' },
];

const PRISMODELL = [
  { key: 'lopande',  label: 'Löpande räkning' },
  { key: 'fastpris', label: 'Fastpris' },
];

// Fallback-värden om Firestore är tomt
const DEFAULT_DEPLOYMENT_TYPES = [
  { key: 'online',  label: 'Online (SaaS)' },
  { key: 'onprem',  label: 'On-premise' },
  { key: 'oklart',  label: 'Oklart' },
];

const DEFAULT_PLANS = [
  { key: 'enterprise',         label: 'Enterprise' },
  { key: 'projekt',            label: 'Projekt' },
  { key: 'enterprise_projekt', label: 'Enterprise + Projekt' },
];

const REVENUE_UNITS = [
  { key: 'ar',      label: 'per år' },
  { key: 'projekt', label: 'per projekt' },
  { key: 'manad',   label: 'per månad' },

];

const MONTHS_SV = ['Januari','Februari','Mars','April','Maj','Juni',
  'Juli','Augusti','September','Oktober','November','December'];


/** Ikonknapparna i den mörka toppraden. */
const TOPP_IKON = {
  color: 'rgba(255,255,255,0.7)',
  '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.08)' },
  '&.Mui-focusVisible': { outline: '2px solid #FF6B00', outlineOffset: 1 },
};

const ACTIVE_STAGES = ['identified', 'qualified', 'demo', 'sandbox', 'proposal', 'negotiation', 'pilot'];
const KANBAN_STAGES = STAGES.filter(s => s.key !== 'sandbox');

const PARTNERSHIP_TAGS = [
  { key: 'IMPENZA', color: '#4527A0', bg: '#EDE7F6' },
];



function isOverdue(dateStr) {
  if (!dateStr) return false;
  return new Date(dateStr) < new Date(new Date().toDateString());
}

function isDueToday(dateStr) {
  if (!dateStr) return false;
  return dateStr === new Date().toISOString().split('T')[0];
}


/** 'YYYY-MM-DD' → Date på lokal middagstid, så Excel inte tappar en dag på tidszonen. */
function toExcelDate(dateStr) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateStr || '');
  if (!m) return '';
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12);
}

const EMPTY_FORM = {
  title: '', companyId: '', type: 'konsult',
  productId: '', status: 'identified', departmentIds: [], ownerId: '',
  estimatedValue: '', revenueUnit: 'ar', probability: '', expectedCloseDate: '',
  nextFollowUp: '', description: '', prismodell: '',
  deploymentType: '', plan: [], contractEndMonth: '', municipality: '',
  hasSandbox: false, offerStatus: '', demoStatus: '', tags: [],
  contactIds: [], mainContactId: '', storlek: null, nastaSteg: '',
};

const SV_MONTHS = { januari:1, februari:2, mars:3, april:4, maj:5, juni:6,
  juli:7, augusti:8, september:9, oktober:10, november:11, december:12 };

function parseMeetingDate(str) {
  if (!str) return '';
  // ISO-ish: "2026-06-24 10:00" or "2026-06-24"
  const isoM = str.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (isoM) return `${isoM[1]}-${isoM[2]}-${isoM[3]}`;
  // Swedish: "tisdag 24 juni 2026 10:00" or "24 juni 2026"
  const svM = str.match(/(\d{1,2})\s+([a-zåäö]+)\s+(\d{4})/i);
  if (svM) {
    const mon = SV_MONTHS[svM[2].toLowerCase()];
    if (mon) return `${svM[3]}-${String(mon).padStart(2,'0')}-${String(svM[1]).padStart(2,'0')}`;
  }
  return '';
}


export default function CRMLeads() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [leads, setLeads] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [products, setProducts] = useState([]);
  const [newCompanyDialog, setNewCompanyDialog] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterDept, setFilterDept] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterOwner, setFilterOwner] = useState('');
  const [filterCreator, setFilterCreator] = useState('');
  const [filterProduct, setFilterProduct] = useState(() => sessionStorage.getItem('leadsFilterProduct') || '');
  const [filterTag, setFilterTag] = useState('');
  // Kundens kategorier (via leadets kund). '__saknas' = kunden saknar värde ur listan.
  const [filterSegment, setFilterSegment] = useState('');
  const [filterOrgTyp, setFilterOrgTyp] = useState('');
  const [leadslistaOpen, setLeadslistaOpen] = useState(false);
  const [hiddenCols, setHiddenCols] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('leadsHiddenCols') || '[]'); } catch { return []; }
  });
  const [colAnchor, setColAnchor] = useState(null);
  const hiddenStagesKey = `leadsHiddenStages_${currentUser?.uid || 'anon'}`;
  const [hiddenStages, setHiddenStages] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`leadsHiddenStages_${currentUser?.uid || 'anon'}`) || '[]'); } catch { return []; }
  });
  const toggleStage = key => {
    const next = hiddenStages.includes(key) ? hiddenStages.filter(k => k !== key) : [...hiddenStages, key];
    setHiddenStages(next);
    localStorage.setItem(hiddenStagesKey, JSON.stringify(next));
  };

  const ALL_COLS = [
    { key: 'company',  label: 'Företag' },
    { key: 'owner',    label: 'Ägare' },
    { key: 'depts',    label: 'Affärsområden' },
    { key: 'product',  label: 'Produkt / Typ' },
    { key: 'value',    label: 'Storlek & offerter' },
    { key: 'followup', label: 'Uppföljningsdatum' },
    { key: 'status',   label: 'Pipeline-status' },
  ];

  function toggleCol(key) {
    const next = hiddenCols.includes(key) ? hiddenCols.filter(k => k !== key) : [...hiddenCols, key];
    setHiddenCols(next);
    sessionStorage.setItem('leadsHiddenCols', JSON.stringify(next));
  }
  const [view, setView] = useState('kanban');
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [importOpen, setImportOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [compactCards, setCompactCards] = useState(false);
  const [deploymentTypes, setDeploymentTypes] = useState(DEFAULT_DEPLOYMENT_TYPES);
  const [plans, setPlans] = useState(DEFAULT_PLANS);
  const [leadPaste, setLeadPaste] = useState('');
  const [formContacts, setFormContacts] = useState([]);
  const [exportStatus, setExportStatus] = useState(''); // '' = ingen export pågår
  const exporting = !!exportStatus;
  const [exportDialog, setExportDialog] = useState(false);
  // Kundprojekt: alla, för raden under flödet, kanbanetiketten och filtret.
  const [kundprojekt, setKundprojekt] = useState([]);
  const [kpLaddade, setKpLaddade] = useState(false);
  const [kpFilter, setKpFilter] = useState(null); // 'har' | 'skydd' | 'isolerad' | null
  // "Skapa lead" från ett kundprojekt: leadet kopplas dit när det sparas.
  const [nyttLeadKundprojekt, setNyttLeadKundprojekt] = useState(null); // kundprojekt | null
  const [allProducts, setAllProducts] = useState([]);
  const [offerter, setOfferter] = useState([]);
  const [moten, setMoten] = useState([]);
  const [motenLaddade, setMotenLaddade] = useState(false);
  // Klick på klockan: bara förfallna uppföljningar. Ersätter statusfiltret så länge det är valt.
  const [visaForfallna, setVisaForfallna] = useState(false);
  // Bekräftelsen efter flytt till Vilande: { leadId, titel, datum } | null
  const [aterkontakt, setAterkontakt] = useState(null);
  const [ioAnchor, setIoAnchor] = useState(null); // Import/export-menyn
  // Under 1280 px blir "Från mail" en ikonknapp; under 900 px bryter raden.
  const smalTopp = useMediaQuery('(max-width:1279.95px)');
  const [period, setPeriod] = useState('vecka');
  const [bokningOpen, setBokningOpen] = useState(false);
  const [analysStatus, setAnalysStatus] = useState(''); // '' = ingen export pågår

  const load = useCallback(async () => {
    setLoading(true);
    const [leadsSnap, companiesSnap, deptsSnap, usersSnap, userSnap, productsSnap, settingsSnap, allaOfferter] =
      await Promise.all([
        getDocs(query(collection(db, 'crmLeads'), orderBy('createdAt', 'desc'))),
        getDocs(query(collection(db, 'crmCompanies'), orderBy('name'))),
        getDocs(collection(db, 'departments')),
        getDocs(collection(db, 'users')),
        getDoc(doc(db, 'users', currentUser.uid)),
        getDocs(query(collection(db, 'products'), orderBy('name'))),
        getDoc(doc(db, 'crmSettings', 'leadOptions')),
        laddaAllaOfferter(),
      ]);
    setLeads(leadsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setOfferter(allaOfferter);
    setCompanies(companiesSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setDepartments(deptsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setUsers(usersSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    const produkter = productsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
    setAllProducts(produkter);
    setProducts(produkter.filter(p => p.active !== false));
    if (userSnap.exists()) setUserProfile({ id: userSnap.id, ...userSnap.data() });
    if (settingsSnap.exists()) {
      const s = settingsSnap.data();
      if (s.deploymentTypes?.length) setDeploymentTypes(s.deploymentTypes);
      if (s.plans?.length) setPlans(s.plans);
    }
    setLoading(false);
    laddaAllaKundprojekt()
      .then(setKundprojekt)
      .catch(e => console.warn('Kunde inte läsa kundprojekt', e))
      .finally(() => setKpLaddade(true));
  }, [currentUser.uid]);

  useEffect(() => { load(); }, [load]);

  // Möten till aktivitetsraden laddas efter tavlan, så att den inte väntar på dem.
  useEffect(() => {
    if (loading) return;
    let aktuell = true;
    setMotenLaddade(false);
    laddaMoten(leads, tidigastePeriodStart())
      .then(m => { if (aktuell) setMoten(m); })
      .finally(() => { if (aktuell) setMotenLaddade(true); });
    return () => { aktuell = false; };
  }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

  // Flatbox-offerter per lead: läses en gång efter tavlan, och bara om
  // användaren har Flatbox-behörighet och det finns Flatbox-leads.
  const [flatboxPerLead, setFlatboxPerLead] = useState({});
  const harFlatboxLeads = useMemo(() => leads.some(l => isFlatboxLead(l, allProducts)), [leads, allProducts]);
  useEffect(() => {
    if (loading || !harFlatboxLeads || !canUseFlatbox(userProfile)) return undefined;
    let aktuell = true;
    getDocs(collection(db, 'flatbox_offers'))
      .then(s => { if (aktuell) setFlatboxPerLead(flatboxOfferterPerLead(s.docs.map(d => d.data()))); })
      .catch(e => console.warn('Flatbox-offerter kunde inte läsas', e));
    return () => { aktuell = false; };
  }, [loading, harFlatboxLeads, userProfile]);
  // Etiketten per lead – bara Flatbox-leads med minst en offert.
  const flatboxEtiketter = useMemo(() => {
    const map = {};
    for (const l of leads) {
      if (!flatboxPerLead[l.id] || !isFlatboxLead(l, allProducts)) continue;
      map[l.id] = { ...flatboxEtikett(flatboxPerLead[l.id]), kampanj: kampanjText(kampanjForLead(flatboxPerLead[l.id])) };
    }
    return map;
  }, [leads, allProducts, flatboxPerLead]);

  useEffect(() => {
    if (searchParams.get('new') !== '1') return;
    openNew(undefined, searchParams.get('companyId') || '');
    const kpId = searchParams.get('kundprojektId');
    if (kpId) {
      laddaKundprojekt(kpId).then(kp => {
        if (!kp) return;
        setNyttLeadKundprojekt(kp);
        setForm(f => (f.title ? f : { ...f, title: kp.namn }));
      }).catch(e => console.warn('Kunde inte läsa kundprojektet', e));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function duplicateLead(lead) {
    // eslint-disable-next-line no-unused-vars
    const { id, createdAt, updatedAt, activityCount, lastActivityDate, lastActivitySummary, starred,
      skedeSedan, skedeshistorik, ...rest } = lead;
    const ref = await addDoc(collection(db, 'crmLeads'), {
      ...rest,
      ...nyttLeadSkedesfalt('identified', currentUser.uid),
      title: `${rest.title} (kopia)`,
      status: 'identified',
      createdBy: currentUser.uid,
      ownerId: currentUser.uid,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    navigate(`/crm/leads/${ref.id}`);
  }

  async function handleSave() {
    if (!form.title.trim()) return;
    setSaving(true);
    const nyttRef = await addDoc(collection(db, 'crmLeads'), {
      ...form,
      ...nyttLeadSkedesfalt(form.status, currentUser.uid),
      estimatedValue: form.estimatedValue ? Number(form.estimatedValue) : null,
      probability: form.probability ? Number(form.probability) : null,
      ownerId: form.ownerId || currentUser.uid,
      prismodell: form.prismodell || null,
      createdBy: currentUser.uid,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    if (nyttLeadKundprojekt && form.companyId) {
      // Kopplas på leadets kunds part; tillbaka till kundprojektet efteråt.
      const kp = nyttLeadKundprojekt;
      setNyttLeadKundprojekt(null);
      try {
        await sparaKundprojektAndringar(kp, medLead(kp, nyttRef.id, form.companyId), currentUser.uid);
        setSaving(false);
        setDialog(false);
        setForm(EMPTY_FORM);
        navigate(`/crm/kundprojekt/${kp.id}`);
        return;
      } catch (e) {
        console.error('Kunde inte koppla leadet till kundprojektet', e);
        alert('Leadet är skapat men kunde inte kopplas till kundprojektet: ' + (e.message || e));
      }
    }
    setSaving(false);
    setDialog(false);
    setForm(EMPTY_FORM);
    load();
  }

  // Kundens kontakter, så att leadet kan kopplas till rätt personer direkt.
  useEffect(() => {
    if (!dialog || !form.companyId) { setFormContacts([]); return; }
    let cancelled = false;
    getDocs(query(collection(db, 'crmCompanies', form.companyId, 'contacts'), orderBy('name')))
      .then(snap => { if (!cancelled) setFormContacts(snap.docs.map(d => ({ id: d.id, ...d.data() }))); })
      .catch(e => console.error('Kunde inte läsa kontakter:', e));
    return () => { cancelled = true; };
  }, [dialog, form.companyId]);

  function toggleFormContact(id) {
    setForm(f => {
      const ids = f.contactIds || [];
      const contactIds = ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id];
      const mainContactId = contactIds.includes(f.mainContactId) ? f.mainContactId : (contactIds[0] || '');
      return { ...f, contactIds, mainContactId };
    });
  }

  // Ny kund (eller kontakt på befintlig kund) från dialogen: uppdatera listan
  // och förvälj kunden och kontakten i leadformuläret.
  function nyKundSparad({ kund, kontaktId, ny }) {
    setCompanies(prev => (ny
      ? [...prev, kund].sort((a, b) => a.name.localeCompare(b.name))
      : prev.map(c => (c.id === kund.id ? { ...c, ...kund } : c))));
    setForm(f => ({ ...f, companyId: kund.id, contactIds: kontaktId ? [kontaktId] : [], mainContactId: kontaktId }));
  }

  function openNew(presetStatus, preCompanyId) {
    setForm({
      ...EMPTY_FORM,
      ownerId: currentUser.uid,
      departmentIds: userProfile?.departmentId ? [userProfile.departmentId] : [],
      status: presetStatus || 'identified',
      ...(preCompanyId ? { companyId: preCompanyId } : {}),
    });
    setLeadPaste('');
    setDialog(true);
  }

  // Alla filter utom status och förfallna. Klockan och tratten räknar på de
  // här leadsen, så att ett klick ger exakt så många kort på tavlan.
  const basFiltrerade = leads.filter(l => {
    const q = search.toLowerCase();
    const company = companies.find(c => c.id === l.companyId);
    const matchSearch = !q ||
      l.title?.toLowerCase().includes(q) ||
      company?.name?.toLowerCase().includes(q);
    const matchDept    = !filterDept    || (l.departmentIds || []).includes(filterDept);
    const matchOwner   = !filterOwner   || l.ownerId === filterOwner;
    const matchCreator = !filterCreator || l.createdBy === filterCreator;
    const matchProduct = !filterProduct || l.productId === filterProduct;
    const matchTag     = !filterTag    || (l.tags || []).includes(filterTag);
    const matchSegment = !filterSegment || (filterSegment === '__saknas'
      ? !SEGMENT_OPTIONS.includes(company?.segment) : company?.segment === filterSegment);
    const matchOrgTyp  = !filterOrgTyp || (filterOrgTyp === '__saknas'
      ? !ORGANISATIONSTYP_OPTIONS.includes(company?.organisationstyp) : company?.organisationstyp === filterOrgTyp);
    return matchSearch && matchDept && matchOwner && matchCreator && matchProduct && matchTag && matchSegment && matchOrgTyp;
  });

  const matchStatus = l => (filterStatus === 'all' ? true
    : filterStatus === 'active' ? ACTIVE_STAGES.includes(l.status)
    : filterStatus === 'closed' ? ['won', 'lost', 'dormant'].includes(l.status)
    : normaliseraSkede(l.status) === filterStatus);
  // Samma tidpunkt för klockan och filtret i en och samma rendering.
  const nu = Date.now();
  const idagDatum = lokalDatum(nu);
  const forfallna = basFiltrerade.filter(l => harForfallenUppfoljning(l, idagDatum));
  const kpMap = useMemo(() => Object.fromEntries(kundprojekt.map(kp => [kp.id, kp])), [kundprojekt]);
  const kpData = useMemo(() => kundprojektSammanfattning(kundprojekt), [kundprojekt]);
  const statusFiltrerade = visaForfallna ? forfallna : basFiltrerade.filter(matchStatus);
  const filtered = kpFilter ? statusFiltrerade.filter(kpLeadPredikat(kpFilter, kpMap)) : statusFiltrerade;

  const offerterMap = useMemo(() => grupperaOfferter(offerter), [offerter]);
  const trattData = tratt(basFiltrerade, nu);
  const aktivitet = aktivitetPerPeriod({ period, leads: basFiltrerade, moten, offerter, now: nu });
  const ekonomi = useMemo(() => ekonomiRader(leads, allProducts, offerterMap), [leads, allProducts, offerterMap]);

  function vaxlaForfallna() {
    setVisaForfallna(v => !v);
    setFilterStatus('all');
  }
  function valjStatus(key) {
    setVisaForfallna(false);
    setFilterStatus(key || 'all');
  }

  /** Skedesbyte från tavlan. Flytt till Vilande visar återkontaktsdatumet. */
  async function bytLeadSkede(leadId, newStatus) {
    const lead = leads.find(l => l.id === leadId);
    if (!lead || lead.status === newStatus) return;
    const patch = await bytSkede(leadId, lead, newStatus, currentUser.uid);
    setLeads(prev => prev.map(l => l.id === leadId ? { ...l, ...patch } : l));
    if (newStatus === 'dormant') {
      setAterkontakt({ leadId, titel: lead.title, datum: patch.nextFollowUp || lead.nextFollowUp || '' });
    }
  }

  async function andraAterkontakt(datum) {
    const { leadId } = aterkontakt;
    const patch = await sattAterkontakt(leadId, datum);
    setLeads(prev => prev.map(l => l.id === leadId ? { ...l, ...patch } : l));
  }

  /** Aktiva filter som chip under filterraden: { key, label, rensa, color?, bg? } */
  const anvandare = id => {
    const u = users.find(x => x.id === id);
    return id === currentUser.uid ? 'mina leads' : u ? (u.displayName || u.name || u.email) : id;
  };
  const statusText = filterStatus === 'active' ? 'aktiva' : filterStatus === 'closed' ? 'avslutade'
    : (STAGES.find(s => s.key === filterStatus)?.label || filterStatus);
  const aktivaFilter = [
    search && { key: 'sok', label: `Sök: "${search}"`, rensa: () => setSearch('') },
    visaForfallna && { key: 'forfallna', label: 'Förfallna uppföljningar', rensa: () => setVisaForfallna(false), color: '#C62828', bg: '#FFEBEE' },
    !visaForfallna && filterStatus !== 'all' && { key: 'status', label: `Status: ${statusText}`, rensa: () => setFilterStatus('all') },
    filterDept && { key: 'ao', label: `Affärsområde: ${departments.find(d => d.id === filterDept)?.name || filterDept}`, rensa: () => setFilterDept('') },
    filterProduct && { key: 'produkt', label: `Produkt: ${products.find(p => p.id === filterProduct)?.name || filterProduct}`,
      rensa: () => { setFilterProduct(''); sessionStorage.removeItem('leadsFilterProduct'); } },
    filterOwner && { key: 'agare', label: `Ägare: ${anvandare(filterOwner)}`, rensa: () => setFilterOwner('') },
    filterCreator && { key: 'skapare', label: `Skapad av: ${anvandare(filterCreator)}`, rensa: () => setFilterCreator('') },
    filterTag && { key: 'samarbete', label: `Samarbete: ${filterTag}`, rensa: () => setFilterTag(''), color: '#4527A0', bg: '#EDE7F6' },
    filterSegment && { key: 'segment', label: `Segment: ${filterSegment === '__saknas' ? 'saknas' : filterSegment}`, rensa: () => setFilterSegment('') },
    filterOrgTyp && { key: 'orgtyp', label: `Organisationstyp: ${filterOrgTyp === '__saknas' ? 'saknas' : filterOrgTyp}`, rensa: () => setFilterOrgTyp('') },
    kpFilter && { key: 'kundprojekt', label: `Kundprojekt: ${KP_LEADFILTER.find(f => f.key === kpFilter)?.kort || kpFilter}`,
      rensa: () => setKpFilter(null), color: '#E65100', bg: '#FFF3E0' },
  ].filter(Boolean);

  /** Sammanfattar de aktiva filtren i en rad text, till exportens rubrikblock. */
  function filterSummary() {
    const userName = id => {
      const u = users.find(x => x.id === id);
      return u ? (u.displayName || u.name || u.email) : id;
    };
    const statusLabel = filterStatus === 'all' ? '' :
      filterStatus === 'active' ? 'Aktiva' :
      filterStatus === 'closed' ? 'Avslutade' :
      (STAGES.find(s => s.key === filterStatus)?.label || filterStatus);
    return [
      visaForfallna && 'förfallna uppföljningar',
      kpFilter     && `kundprojekt: ${KP_LEADFILTER.find(f => f.key === kpFilter)?.kort || kpFilter}`,
      search       && `sök "${search}"`,
      statusLabel  && `status ${statusLabel}`,
      filterDept   && `affärsområde ${departments.find(d => d.id === filterDept)?.name || filterDept}`,
      filterProduct&& `produkt ${products.find(p => p.id === filterProduct)?.name || filterProduct}`,
      filterOwner  && `ägare ${userName(filterOwner)}`,
      filterCreator&& `skapad av ${userName(filterCreator)}`,
      filterTag    && `samarbete ${filterTag}`,
      filterSegment && `segment ${filterSegment === '__saknas' ? 'saknas' : filterSegment}`,
      filterOrgTyp  && `organisationstyp ${filterOrgTyp === '__saknas' ? 'saknas' : filterOrgTyp}`,
    ].filter(Boolean).join(', ');
  }

  /** Plattar ut de filtrerade leadsen till exportrader (etiketter, inte nycklar). */
  function buildLeadExportRows() {
    return filtered.map(lead => {
      const company = companies.find(c => c.id === lead.companyId);
      const owner   = users.find(u => u.id === lead.ownerId);
      const creator = users.find(u => u.id === lead.createdBy);
      const product = products.find(p => p.id === lead.productId);
      const st      = stageInfo(lead.status);
      const leadOfferter = offerterMap[lead.id] || [];
      const planKeys = Array.isArray(lead.plan) ? lead.plan : (lead.plan ? [lead.plan] : []);
      const value = lead.estimatedValue != null && lead.estimatedValue !== '' ? Number(lead.estimatedValue) : '';
      const prob  = lead.probability   != null && lead.probability   !== '' ? Number(lead.probability)   : '';

      return {
        _bild:             exportBildkalla(company, 'logo'),
        _statusColor:      st.color,
        _statusBg:         st.bg,
        _followUpOverdue:  isOverdue(lead.nextFollowUp),

        company:      company?.name || '',
        title:        lead.title || '',
        status:       st.label,
        product:      product?.name || BASE_TYPES.find(t => t.key === lead.type)?.label || lead.type || '',
        depts:        departments.filter(d => (lead.departmentIds || []).includes(d.id)).map(deptCode).join(', '),
        owner:        owner   ? (owner.displayName   || owner.name   || owner.email)   : '',
        creator:      creator ? (creator.displayName || creator.name || creator.email) : '',
        value,
        unit:         REVENUE_UNITS.find(u => u.key === lead.revenueUnit)?.label || '',
        probability:  prob === '' ? '' : prob / 100,
        weighted:     value === '' || prob === '' ? '' : Math.round(value * prob) / 100,
        prismodell:   PRISMODELL.find(p => p.key === lead.prismodell)?.label || '',
        deployment:   deploymentTypes.find(d => d.key === lead.deploymentType)?.label || '',
        plan:         planKeys.map(k => plans.find(p => p.key === k)?.label || k).join(', '),
        municipality: lead.municipality || '',
        nextFollowUp: toExcelDate(lead.nextFollowUp),
        expectedClose:toExcelDate(lead.expectedCloseDate),
        contractEnd:  lead.contractEndMonth || '',
        offerStatus:  OFFER_STATUSES.find(o => o.key === lead.offerStatus)?.label || '',
        demoStatus:   DEMO_STATUSES.find(d => d.key === lead.demoStatus)?.label || '',
        sandbox:      lead.hasSandbox || lead.status === 'sandbox' ? 'Ja' : '',
        tags:         (lead.tags || []).join(', '),
        orgNumber:    company?.orgNumber || '',
        city:         company?.city || '',
        website:      company?.website || '',
        phone:        company?.phone || '',
        description:  lead.description || '',
        storlek:      lead.storlek || '',
        offerCount:   leadOfferter.length || '',
        lead_id:         lead.id,
        kund_id:         lead.companyId || '',
        huvudkontakt_id: lead.mainContactId || '',
        kontakt_ids:     (lead.contactIds || []).join(', '),
        offerter:     leadOfferter.map(o => [
          o.datum, o.namn,
          o.beloppKSEK != null ? `${Number(o.beloppKSEK).toLocaleString('sv-SE')} KSEK` : '',
          OFFERT_STATUSAR.find(x => x.key === o.status)?.label || o.status,
        ].filter(Boolean).join(' · ')).join('\n'),
      };
    });
  }

  // Analysexport: alla flikar (leads, kunder, kontakter, aktiviteter, offerter,
  // skedeshistorik, Flatbox-offerter) för de leads som syns med filtren.
  async function handleAnalysExport() {
    if (analysStatus || filtered.length === 0) return;
    setAnalysStatus('Förbereder…');
    try {
      const extra = await laddaAnalysData(filtered, setAnalysStatus, kundprojektKunder(filtered));
      setAnalysStatus('Skriver Excel…');
      const { blad } = byggAnalysBlad({
        leads: filtered, companies, users, products: allProducts, departments, stages: STAGES,
        offerterMap, kundprojekt, allaLeads: leads, ...extra,
      });
      const now = new Date();
      await skrivAnalysExcel(blad, {
        exportedAt: now,
        exportedBy: userProfile?.displayName || currentUser.email || '',
        fileName: `lagbasn-affarer-analys-${now.toISOString().slice(0, 10)}.xlsx`,
      });
    } catch (e) {
      console.error('Analysexport misslyckades', e);
      alert('Kunde inte skapa analysfilen: ' + (e.message || e));
    } finally {
      setAnalysStatus('');
    }
  }

  /** Kunder som är parter i kundprojekt i exporten (för kontakternas namn). */
  function kundprojektKunder(urval) {
    const kunder = new Set(urval.map(l => l.companyId).filter(Boolean));
    return urvalKundprojekt(kundprojekt, [...kunder]).flatMap(kp => (kp.parter || []).map(p => p.kundId));
  }

  // "Exportera": Leads, Kunder, Kontakter och Om filen, med logotyper (och
  // kontaktfoton om det kryssats i) för de leads som syns med filtren.
  async function handleExportExcel({ medFoton = false } = {}) {
    if (exporting || filtered.length === 0) return;
    setExportDialog(false);
    setExportStatus('Läser kontakter…');
    try {
      const now = new Date();
      const contactsByCompany = await laddaKontakter(filtered, kundprojektKunder(filtered));
      const blad = byggVanligaBlad({
        leadRader: buildLeadExportRows(), leads: filtered, companies, departments,
        contactsByCompany, kundstatusar: COMPANY_STATUSES_LIST, medFoton,
        kundprojekt, allaLeads: leads, users,
        meta: {
          exportedAt: now,
          exportedBy: userProfile?.displayName || currentUser.displayName || currentUser.email || '',
          filterSummary: filterSummary(),
        },
      });
      await exportVanligExcel(blad, {
        exportedAt: now,
        fileName: `affarer-pipeline-${now.toISOString().slice(0, 10)}.xlsx`,
        onProgress: setExportStatus,
      });
    } catch (e) {
      console.error('Excel-export misslyckades', e);
      alert('Kunde inte skapa Excel-filen: ' + (e.message || e));
    } finally {
      setExportStatus('');
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f0f2f5' }}>
      {/* Topprad: rubrik, vyväljare, ikonknappar, primära knappar. Under 900 px
          hamnar knapparna på en egen rad i stället för att tryckas ihop. */}
      <Box sx={{ bgcolor: '#1a1a1a', color: 'white', py: 1.5, px: 3,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', columnGap: 2, rowGap: 1.5,
        position: 'sticky', top: 0, zIndex: 100 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
          <LagbasLogo />
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.2)', mx: -0.5 }} />
          <IconButton color="inherit" size="small" onClick={() => navigate(-1)} aria-label="Tillbaka">
            <ArrowBackIcon />
          </IconButton>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ whiteSpace: 'nowrap' }}>Affärer – Pipeline</Typography>
            <Typography variant="caption" sx={{ color: '#aaa', whiteSpace: 'nowrap' }}>
              {leads.filter(l => ACTIVE_STAGES.includes(l.status)).length} aktiva leads
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexShrink: 0, ml: 'auto',
          width: { xs: '100%', md: 'auto' }, justifyContent: 'flex-end',
          flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
          <ToggleButtonGroup size="small" value={view} exclusive
            onChange={(_, v) => v && setView(v)}
            sx={{ mr: 0.5, '& .MuiToggleButton-root': { color: 'white',
              borderColor: 'rgba(255,255,255,0.3)',
              '&.Mui-selected': { bgcolor: '#FF6B00', color: 'white', borderColor: '#FF6B00' } } }}>
            <ToggleButton value="kanban">
              <Tooltip title="Kanban-vy"><ViewKanbanIcon fontSize="small" /></Tooltip>
            </ToggleButton>
            <ToggleButton value="list">
              <Tooltip title="Listvy"><ViewListIcon fontSize="small" /></Tooltip>
            </ToggleButton>
            <ToggleButton value="calendar">
              <Tooltip title="Kalendervy"><CalendarMonthIcon fontSize="small" /></Tooltip>
            </ToggleButton>
            <ToggleButton value="ekonomi" sx={{ textTransform: 'none', fontSize: '0.75rem', fontWeight: 700, px: 1.25 }}>
              <Tooltip title="Ekonomi – produktöversikt i KSEK"><span>Ekonomi</span></Tooltip>
            </ToggleButton>
            <ToggleButton value="kundprojekt" sx={{ textTransform: 'none', fontSize: '0.75rem', fontWeight: 700, px: 1.25 }}>
              <Tooltip title="Kundprojekt – kundernas projekt som säljunderlag"><span>Kundprojekt</span></Tooltip>
            </ToggleButton>
          </ToggleButtonGroup>

          <IkonKnapp onClick={vaxlaForfallna} siffra={forfallna.length}
            etikett={`Påminnelser – ${forfallna.length} förfallna uppföljningar`}
            tips={visaForfallna
              ? 'Påminnelser – visa hela tavlan igen'
              : forfallna.length
                ? `Påminnelser – ${forfallna.length} förfallna uppföljningar. Klicka för att visa dem på tavlan.`
                : 'Påminnelser – inga förfallna uppföljningar'}
            aria-pressed={visaForfallna}
            sx={{ ...TOPP_IKON, ...(visaForfallna ? { color: 'white', bgcolor: 'rgba(255,255,255,0.14)' } : {}) }}>
            <NotificationsActiveIcon />
          </IkonKnapp>
          <IkonKnapp etikett="Inställningar" tips="Inställningar – licenstyp och driftsättning"
            onClick={() => setSettingsOpen(true)} sx={TOPP_IKON}>
            <TuneIcon />
          </IkonKnapp>
          <IkonKnapp etikett="Import och export"
            tips={analysStatus ? `Exportera för analys: ${analysStatus}` : exportStatus ? `Exportera: ${exportStatus}` : 'Import och export'}
            onClick={e => setIoAnchor(e.currentTarget)}
            aria-haspopup="menu" aria-expanded={!!ioAnchor} aria-controls={ioAnchor ? 'pipeline-io-meny' : undefined}
            sx={TOPP_IKON}>
            {exporting || analysStatus
              ? <CircularProgress size={20} sx={{ color: 'inherit' }} />
              : <ImportExportIcon />}
          </IkonKnapp>
          <IkonKnapp etikett="Ny kund"
            onClick={() => { setNewCompanyDialog(true); }}
            sx={TOPP_IKON}>
            <BusinessIcon />
          </IkonKnapp>

          {smalTopp ? (
            <IkonKnapp etikett="Nytt lead från bokningsmail" onClick={() => setBokningOpen(true)}
              sx={{ ...TOPP_IKON, border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', ml: 0.5 }}>
              <MarkEmailReadIcon />
            </IkonKnapp>
          ) : (
            <Hjalptext title="Nytt lead från bokningsmail">
              <Button variant="outlined" startIcon={<MarkEmailReadIcon />} onClick={() => setBokningOpen(true)}
                sx={{ ml: 0.5, height: 40, whiteSpace: 'nowrap', flexShrink: 0, color: 'white',
                  borderColor: 'rgba(255,255,255,0.4)', fontWeight: 600,
                  '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.08)' } }}>
                Från mail
              </Button>
            </Hjalptext>
          )}
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => openNew()}
            sx={{ height: 40, whiteSpace: 'nowrap', flexShrink: 0,
              bgcolor: '#FF6B00', '&:hover': { bgcolor: '#e55a00' }, fontWeight: 700 }}>
            Nytt lead
          </Button>
        </Box>
      </Box>

      <Menu id="pipeline-io-meny" anchorEl={ioAnchor} open={!!ioAnchor} onClose={() => setIoAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <MenuItem onClick={() => { setIoAnchor(null); setImportOpen(true); }}>
          <ListItemIcon><UploadFileIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Importera" secondary="Leads från Excel/CSV" />
        </MenuItem>
        <MenuItem onClick={() => { setIoAnchor(null); setLeadslistaOpen(true); }}>
          <ListItemIcon><PlaylistAddIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Importera leadslista" secondary="Från säljpartner (t.ex. Comdeva), med förhandsgranskning" />
        </MenuItem>
        <MenuItem disabled={exporting || loading || filtered.length === 0}
          onClick={() => { setIoAnchor(null); setExportDialog(true); }}>
          <ListItemIcon><FileDownloadIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary={exportStatus || 'Exportera'}
            secondary={filtered.length === 0 ? 'Inga leads matchar filtret' : `${filtered.length} filtrerade leads till Excel`} />
        </MenuItem>
        <MenuItem disabled={!!analysStatus || loading || filtered.length === 0}
          onClick={() => { setIoAnchor(null); handleAnalysExport(); }}>
          <ListItemIcon><TableChartIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary={analysStatus || 'Exportera för analys'}
            secondary="Kunder, kontakter, kommunikation, offerter och Flatbox-offerter" />
        </MenuItem>
      </Menu>

      <LeadslistaImportDialog open={leadslistaOpen} onClose={() => setLeadslistaOpen(false)}
        companies={companies} leads={leads} products={allProducts} departments={departments}
        uid={currentUser.uid} onImported={load} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {view === 'kundprojekt' ? (
          <KundprojektListvy kundprojekt={kundprojekt} companies={companies} navigate={navigate}
            laddar={loading || !kpLaddade} />
        ) : view === 'ekonomi' ? (
          loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}><CircularProgress /></Box>
          ) : (
            <EkonomiVy data={ekonomi} stages={STAGES} navigate={navigate} />
          )
        ) : (
        <>
        {/* Tratt – klick på ett skede filtrerar tavlan till skedet */}
        <PipelineTratt data={trattData} stages={STAGES}
          valtSkede={!visaForfallna && STAGES.some(st => st.key === filterStatus) ? filterStatus : null}
          onValjSkede={valjStatus} />

        {/* Kundprojekt – klick filtrerar tavlan till leads med sådana kundprojekt */}
        <KundprojektRad data={kpData} valt={kpFilter} onValj={setKpFilter} laddar={!kpLaddade} />

        <AktivitetRad period={period} onPeriod={setPeriod} varden={aktivitet}
          motenLaddade={motenLaddade} demosMatbara={demosMatbara(basFiltrerade, period, nu)} />

        {/* Filters */}
        <Box sx={{ display: 'flex', gap: 1.5, mb: aktivaFilter.length ? 1.25 : 2.5, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField size="small" placeholder="Sök lead eller företag..."
            value={search} onChange={e => setSearch(e.target.value)}
            sx={{ flex: 1, minWidth: 200, bgcolor: 'white', borderRadius: 1 }}
            InputProps={{ startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 18 }} />
              </InputAdornment>
            )}} />
          <TextField select size="small" value={visaForfallna ? '' : filterStatus}
            onChange={e => valjStatus(e.target.value)}
            SelectProps={{ displayEmpty: true, renderValue: v => (v === ''
              ? 'Förfallna'
              : v === 'active' ? 'Aktiva' : v === 'all' ? 'Alla' : v === 'closed' ? 'Avslutade'
              : STAGES.find(st => st.key === v)?.label || v) }}
            sx={{ minWidth: 150, bgcolor: 'white' }} label="Status">
            <MenuItem value="" sx={{ display: 'none' }}>Förfallna</MenuItem>
            <MenuItem value="active">Aktiva</MenuItem>
            <MenuItem value="all">Alla</MenuItem>
            <MenuItem value="closed">Avslutade</MenuItem>
            {STAGES.map(s => <MenuItem key={s.key} value={s.key}>{s.label}</MenuItem>)}
          </TextField>
          <TextField select size="small" value={filterDept}
            onChange={e => setFilterDept(e.target.value)}
            sx={{ minWidth: 170, bgcolor: 'white' }} label="Affärsområde">
            <MenuItem value="">Alla AO</MenuItem>
            {departments.map(d => <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>)}
          </TextField>
          {products.length > 0 && (
            <TextField select size="small" value={filterProduct}
              onChange={e => { setFilterProduct(e.target.value); sessionStorage.setItem('leadsFilterProduct', e.target.value); }}
              sx={{ minWidth: 160, bgcolor: 'white' }} label="Produkt">
              <MenuItem value="">Alla produkter</MenuItem>
              {products.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
            </TextField>
          )}
          <TextField select size="small" value={filterSegment}
            onChange={e => setFilterSegment(e.target.value)}
            sx={{ minWidth: 170, bgcolor: 'white' }} label="Segment">
            <MenuItem value="">Alla segment</MenuItem>
            <MenuItem value="__saknas"><i>Kunden saknar segment</i></MenuItem>
            {SEGMENT_OPTIONS.map(o => (
              <MenuItem key={o} value={o}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: segmentColor(o), flexShrink: 0 }} />{o}
                </Box>
              </MenuItem>
            ))}
          </TextField>
          <TextField select size="small" value={filterOrgTyp}
            onChange={e => setFilterOrgTyp(e.target.value)}
            sx={{ minWidth: 170, bgcolor: 'white' }} label="Organisationstyp">
            <MenuItem value="">Alla typer</MenuItem>
            <MenuItem value="__saknas"><i>Kunden saknar typ</i></MenuItem>
            {ORGANISATIONSTYP_OPTIONS.map(o => <MenuItem key={o} value={o}>{o}</MenuItem>)}
          </TextField>
          <TextField select size="small" value={filterOwner}
            onChange={e => setFilterOwner(e.target.value)}
            sx={{ minWidth: 150, bgcolor: 'white' }} label="Ägare">
            <MenuItem value="">Alla ägare</MenuItem>
            <MenuItem value={currentUser.uid}>Mina leads</MenuItem>
            {users
              .filter(u => u.id !== currentUser.uid && leads.some(l => l.ownerId === u.id))
              .map(u => <MenuItem key={u.id} value={u.id}>{u.displayName || u.email}</MenuItem>)}
          </TextField>
          <TextField select size="small" value={filterCreator}
            onChange={e => setFilterCreator(e.target.value)}
            sx={{ minWidth: 150, bgcolor: 'white' }} label="Skapad av">
            <MenuItem value="">Alla skapare</MenuItem>
            {users
              .filter(u => leads.some(l => l.createdBy === u.id))
              .map(u => <MenuItem key={u.id} value={u.id}>{u.displayName || u.email}</MenuItem>)}
          </TextField>
          <TextField select size="small" value={filterTag}
            onChange={e => setFilterTag(e.target.value)}
            sx={{ minWidth: 140, bgcolor: filterTag ? '#EDE7F6' : 'white',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: filterTag ? '#4527A0' : undefined } }}
            label="Samarbete">
            <MenuItem value="">Alla</MenuItem>
            {PARTNERSHIP_TAGS.map(t => <MenuItem key={t.key} value={t.key}>{t.key}</MenuItem>)}
          </TextField>
          <TextField select size="small" value={kpFilter || ''}
            onChange={e => setKpFilter(e.target.value || null)}
            sx={{ minWidth: 170, bgcolor: kpFilter ? '#FFF3E0' : 'white',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: kpFilter ? '#E65100' : undefined } }}
            label="Kundprojekt">
            <MenuItem value="">Alla</MenuItem>
            {KP_LEADFILTER.map(f => <MenuItem key={f.key} value={f.key}>{f.label}</MenuItem>)}
          </TextField>
          {view === 'list' && (
            <>
              <Tooltip title="Visa / dölj kolumner">
                <IconButton size="small" onClick={e => setColAnchor(e.currentTarget)}
                  sx={{
                    border: '1px solid', borderRadius: 1,
                    borderColor: hiddenCols.length > 0 ? '#FF6B00' : 'rgba(0,0,0,0.23)',
                    bgcolor: hiddenCols.length > 0 ? 'rgba(255,107,0,0.08)' : 'white',
                    color: hiddenCols.length > 0 ? '#FF6B00' : 'inherit',
                    '&:hover': { borderColor: '#FF6B00', color: '#FF6B00' },
                  }}>
                  <ViewColumnIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Popover open={Boolean(colAnchor)} anchorEl={colAnchor}
                onClose={() => setColAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
                <Box sx={{ p: 2, minWidth: 200 }}>
                  <Typography variant="caption" fontWeight="bold" color="text.secondary"
                    sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1 }}>
                    Visa kolumner
                  </Typography>
                  {ALL_COLS.map(col => (
                    <FormControlLabel key={col.key}
                      control={
                        <Checkbox size="small" checked={!hiddenCols.includes(col.key)}
                          onChange={() => toggleCol(col.key)}
                          sx={{ py: 0.5, '&.Mui-checked': { color: '#FF6B00' } }} />
                      }
                      label={<Typography variant="body2">{col.label}</Typography>}
                      sx={{ display: 'flex', m: 0 }}
                    />
                  ))}
                  {hiddenCols.length > 0 && (
                    <Button size="small" sx={{ mt: 1, color: '#FF6B00', fontSize: '0.72rem' }}
                      onClick={() => { setHiddenCols([]); sessionStorage.removeItem('leadsHiddenCols'); setColAnchor(null); }}>
                      Visa alla
                    </Button>
                  )}
                </Box>
              </Popover>
            </>
          )}
          {view === 'kanban' && (
            <>
              <Tooltip title={compactCards ? 'Visa fullständiga kort' : 'Kompakt vy (bara leadnamn)'}>
                <IconButton size="small" onClick={() => setCompactCards(c => !c)}
                  sx={{
                    border: '1px solid', borderRadius: 1,
                    borderColor: compactCards ? '#FF6B00' : 'rgba(0,0,0,0.23)',
                    bgcolor: compactCards ? 'rgba(255,107,0,0.08)' : 'white',
                    color: compactCards ? '#FF6B00' : 'inherit',
                    '&:hover': { borderColor: '#FF6B00', color: '#FF6B00' },
                  }}>
                  <ViewListIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              {hiddenStages.length > 0 && (
                <Tooltip title="Återställ dolda kolumner">
                  <Button size="small" variant="outlined" onClick={() => {
                    setHiddenStages([]); sessionStorage.removeItem('leadsHiddenStages');
                  }} sx={{
                    fontSize: '0.72rem', borderColor: '#FF6B00', color: '#FF6B00',
                    '&:hover': { borderColor: '#e55a00', bgcolor: '#fff3ec' },
                  }}>
                    Visa alla ({hiddenStages.length} dolda)
                  </Button>
                </Tooltip>
              )}
            </>
          )}
        </Box>

        {/* Aktiva filter – varför tavlan är filtrerad */}
        {aktivaFilter.length > 0 && (
          <Box sx={{ display: 'flex', gap: 1, mb: 2.5, flexWrap: 'wrap', alignItems: 'center' }}>
            <Typography variant="caption" color="text.secondary" fontWeight={700}
              sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
              Aktiva filter
            </Typography>
            {aktivaFilter.map(f => (
              <Chip key={f.key} size="small" label={f.label} onDelete={f.rensa}
                sx={{ fontWeight: 600, bgcolor: f.bg || 'white', color: f.color || 'text.primary',
                  border: '1px solid', borderColor: f.color || 'divider',
                  '& .MuiChip-deleteIcon': { color: f.color || undefined } }} />
            ))}
            {visaForfallna && (
              <Button size="small" onClick={() => navigate('/crm/reminders')}
                sx={{ textTransform: 'none', color: '#C62828', fontWeight: 600 }}>
                Mina påminnelser
              </Button>
            )}
            <Typography variant="caption" color="text.secondary">
              {filtered.length} {filtered.length === 1 ? 'lead' : 'leads'}
            </Typography>
            {aktivaFilter.length > 1 && (
              <Button size="small" onClick={() => aktivaFilter.forEach(f => f.rensa())}
                sx={{ textTransform: 'none', color: '#FF6B00' }}>
                Rensa alla
              </Button>
            )}
          </Box>
        )}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
            <CircularProgress />
          </Box>
        ) : view === 'kanban' ? (
          <Box sx={{
            overflowX: 'auto', mx: -3, px: 3,
            pb: 1,
            '&::-webkit-scrollbar': { height: 6 },
            '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
            '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(0,0,0,0.18)', borderRadius: 3,
              '&:hover': { bgcolor: 'rgba(0,0,0,0.32)' } },
          }}>
            <KanbanView
              leads={filtered} companies={companies} departments={departments}
              users={users} products={products} navigate={navigate} openNew={openNew}
              compact={compactCards}
              hiddenStages={hiddenStages} toggleStage={toggleStage}
              plans={plans} deploymentTypes={deploymentTypes}
              offerterMap={offerterMap} kpMap={kpMap} flatboxEtiketter={flatboxEtiketter}
              onStatusChange={bytLeadSkede}
              onToggleStar={async (leadId, current) => {
                await updateDoc(doc(db, 'crmLeads', leadId), { starred: !current });
                setLeads(prev => prev.map(l => l.id === leadId ? { ...l, starred: !current } : l));
              }}
              onToggleSandbox={async (leadId, lead) => {
                // sandbox → demo är samma skede, så bytSkede loggar inget.
                const updates = lead.status === 'sandbox'
                  ? await bytSkede(leadId, lead, 'demo', currentUser.uid, { hasSandbox: true })
                  : { hasSandbox: !lead.hasSandbox, updatedAt: new Date() };
                if (lead.status !== 'sandbox') await updateDoc(doc(db, 'crmLeads', leadId), updates);
                setLeads(prev => prev.map(l => l.id === leadId ? { ...l, ...updates } : l));
              }}
              onCycleOfferStatus={async (leadId, current) => {
                const cycle = ['', 'skapad', 'skickad', 'uppföljd', 'accepterad'];
                const next = cycle[(cycle.indexOf(current || '') + 1) % cycle.length];
                await updateDoc(doc(db, 'crmLeads', leadId), { offerStatus: next, updatedAt: new Date() });
                setLeads(prev => prev.map(l => l.id === leadId ? { ...l, offerStatus: next } : l));
              }}
              onCycleDemoStatus={async (leadId, current) => {
                const cycle = ['', 'bokad', 'genomförd', 'utebliven', 'avbokad'];
                const next = cycle[(cycle.indexOf(current || '') + 1) % cycle.length];
                // nextFollowUp bär mötestiden så länge demon är bokad. Vid avbokning
                // är den tiden död, och nästa steg är att höra av sig om en ny — inte
                // ett datum man vet ännu. Uppföljningen flyttas därför till idag, så
                // att leadet ligger kvar bland de förfallna tills ny tid är satt.
                const patch = DEMO_NEEDS_REBOOKING.includes(next)
                  ? { demoStatus: next, nextFollowUp: new Date().toISOString().split('T')[0], nextFollowUpStatus: '' }
                  : { demoStatus: next };
                await updateDoc(doc(db, 'crmLeads', leadId), { ...patch, updatedAt: new Date() });
                setLeads(prev => prev.map(l => l.id === leadId ? { ...l, ...patch } : l));
              }}
              onDuplicate={duplicateLead}
            />
          </Box>
        ) : view === 'calendar' ? (
          <CalendarView
            leads={filtered} companies={companies} users={users} navigate={navigate}
          />
        ) : (
          <ListView
            leads={filtered} companies={companies} departments={departments}
            users={users} products={products} navigate={navigate}
            hiddenCols={hiddenCols} offerterMap={offerterMap} flatboxEtiketter={flatboxEtiketter}
          />
        )}
        </>
        )}
      </Container>

      <AterkontaktBekraftelse key={aterkontakt ? `${aterkontakt.leadId}-${aterkontakt.datum}` : 'ingen'}
        bekraftelse={aterkontakt} onAndra={andraAterkontakt} onStang={() => setAterkontakt(null)} />

      <ExportDialog open={exportDialog} antal={filtered.length}
        onClose={() => setExportDialog(false)} onExportera={handleExportExcel} />

      <BokningsmailDialog open={bokningOpen} onClose={() => setBokningOpen(false)}
        companies={companies} leads={leads} products={products} departments={departments}
        currentUser={currentUser} userProfile={userProfile} navigate={navigate}
        onSkapad={() => load()} />

      {/* New lead dialog */}
      <Dialog open={dialog} onClose={() => { setDialog(false); setNyttLeadKundprojekt(null); }} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <TrendingUpIcon sx={{ color: '#FF6B00', fontSize: 28 }} />
            <Box>
              <Typography variant="h6" fontWeight="bold">Nytt lead</Typography>
              <Typography variant="caption" color="text.secondary">
                Lägg in affärsmöjligheten i pipeline
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

            {nyttLeadKundprojekt && (
              <Alert severity="info" onClose={() => setNyttLeadKundprojekt(null)}>
                Leadet kopplas till kundprojektet <b>{nyttLeadKundprojekt.namn}</b> när det sparas.
              </Alert>
            )}

            {/* ── Snabbfyll från bokningsmail ── */}
            <Box sx={{ bgcolor: '#fff8e1', borderRadius: 2, p: 2, border: '1px solid #ffe082' }}>
              <Typography variant="caption" fontWeight="bold"
                sx={{ color: '#E65100', display: 'block', mb: 1, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                Snabbfyll — klistra in bokningsmail
              </Typography>
              <TextField fullWidth size="small" multiline minRows={1}
                placeholder="Klistra in hela bokningsmailet från säljsystemet här"
                value={leadPaste}
                onChange={e => {
                  const val = e.target.value;
                  setLeadPaste(val);
                  const b = parseBookingEmail(val);
                  if (b) {
                    const match = b.companyName
                      ? companies.find(c => c.name.toLowerCase() === b.companyName.toLowerCase())
                      : null;
                    const autoTitle = b.companyName || '';
                    const searchText = [b.meetingNotes, b.meetingSubject, val].filter(Boolean).join(' ').toUpperCase();
                    const matchedProduct = products.find(p => p.name && searchText.includes(p.name.toUpperCase()));
                    const meetingDate = parseMeetingDate(b.meetingStart);
                    setForm(f => {
                      // Bokningsmailen kommer från Comdeva och landar alltid på MVL —
                      // oberoende av om produkten kunde matchas ur mailtexten.
                      const mvlDept = departments.find(d => d.name?.toUpperCase().includes('MVL'));
                      const deptIds = f.departmentIds || [];
                      const newDeptIds = mvlDept && !deptIds.includes(mvlDept.id) ? [...deptIds, mvlDept.id] : deptIds;
                      return {
                        ...f,
                        departmentIds: newDeptIds,
                        ...(match && !f.companyId ? { companyId: match.id, contactIds: [], mainContactId: '' } : {}),
                        ...(autoTitle && !f.title ? { title: autoTitle } : {}),
                        ...(b.meetingNotes && !f.description ? { description: b.meetingNotes } : {}),
                        ...(matchedProduct && !f.productId ? { productId: matchedProduct.id, type: 'produkt' } : {}),
                        ...(meetingDate && !f.nextFollowUp ? { nextFollowUp: meetingDate } : {}),
                        // Ett bokningsmail betyder att demon är bokad – sätt status om användaren inte redan valt något annat
                        ...(f.status === 'identified' ? { status: 'demo' } : {}),
                        ...(!f.demoStatus ? { demoStatus: 'bokad' } : {}),
                      };
                    });
                  }
                }}
                helperText="Väljer företag, produkt, titel och MVL automatiskt — och sätter status Demo / Demo bokad"
                InputProps={{ sx: { bgcolor: 'white' } }}
              />
            </Box>

            {/* Titel */}
            <TextField fullWidth size="small" label="Titel / Rubrik *" autoFocus
              placeholder="t.ex. FLATBOX-pilotprojekt hos Skanska"
              value={form.title}
              onChange={e => setForm(f => ({ ...f, title: e.target.value }))} />

            {/* Rad: Företag + [+] + Typ */}
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
              <TextField select size="small" fullWidth label="Företag"
                value={form.companyId}
                onChange={e => setForm(f => ({ ...f, companyId: e.target.value, contactIds: [], mainContactId: '' }))}>
                <MenuItem value="">– Välj företag –</MenuItem>
                {companies.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
              </TextField>
              <Tooltip title="Skapa nytt företag">
                <IconButton size="small" onClick={() => setNewCompanyDialog(true)}
                  sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, flexShrink: 0 }}>
                  <AddIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <TextField select size="small" label="Typ" sx={{ width: 180, flexShrink: 0 }}
                value={form.type}
                onChange={e => {
                  const newType = e.target.value;
                  setForm(f => {
                    const mvlDept = departments.find(d => d.name?.toUpperCase().includes('MVL'));
                    const shouldTagMvl = mvlDept && (newType === 'produkt' || newType === 'kombination');
                    const deptIds = f.departmentIds || [];
                    const newDeptIds = shouldTagMvl && !deptIds.includes(mvlDept.id)
                      ? [...deptIds, mvlDept.id]
                      : deptIds;
                    return { ...f, type: newType, productId: '', departmentIds: newDeptIds };
                  });
                }}>
                {BASE_TYPES.map(t => <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>)}
              </TextField>
            </Box>

            {form.companyId && (
              <Box>
                <Typography variant="caption" color="text.secondary" fontWeight="bold"
                  sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 0.75 }}>
                  Kontakter i affären
                </Typography>
                {formContacts.length === 0 ? (
                  <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    Kunden har inga kontakter ännu — lägg till dem på leadet efteråt.
                  </Typography>
                ) : (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                    {formContacts.map(c => {
                      const sel = (form.contactIds || []).includes(c.id);
                      const isMain = sel && form.mainContactId === c.id;
                      return (
                        <Tooltip key={c.id} title={sel
                          ? (isMain ? 'Huvudkontakt — klicka för att koppla bort' : 'Klicka på stjärnan för att göra till huvudkontakt')
                          : [c.role, c.email].filter(Boolean).join(' · ') || 'Koppla till leadet'}>
                          <Chip size="small" label={c.name || c.email}
                            onClick={() => toggleFormContact(c.id)}
                            icon={sel ? (
                              <Box component="span" onClick={e => { e.stopPropagation(); setForm(f => ({ ...f, mainContactId: c.id })); }}
                                sx={{ display: 'inline-flex', pl: 0.5, color: 'inherit !important' }}>
                                {isMain ? <StarIcon sx={{ fontSize: 14 }} /> : <StarBorderIcon sx={{ fontSize: 14 }} />}
                              </Box>
                            ) : undefined}
                            variant={sel ? 'filled' : 'outlined'}
                            sx={{ cursor: 'pointer', bgcolor: sel ? '#FF6B00' : 'transparent',
                              color: sel ? 'white' : 'text.primary', '& .MuiChip-icon': { color: 'white' } }} />
                        </Tooltip>
                      );
                    })}
                  </Box>
                )}
              </Box>
            )}

            {/* Rad: Pipeline-steg + Ägare + Prismodell */}
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <TextField select size="small" label="Pipeline-steg" sx={{ width: 230, flexShrink: 0 }}
                value={form.status}
                onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                {STAGES.map(s => <MenuItem key={s.key} value={s.key}>{s.label}</MenuItem>)}
              </TextField>
              <TextField select size="small" label="Ägare" sx={{ flex: 1 }}
                value={form.ownerId}
                onChange={e => setForm(f => ({ ...f, ownerId: e.target.value }))}>
                {users
                  .slice()
                  .sort((a, b) => (a.displayName || a.email).localeCompare(b.displayName || b.email, 'sv'))
                  .map(u => (
                    <MenuItem key={u.id} value={u.id}>
                      {u.displayName || u.email}{u.id === currentUser.uid && ' (jag)'}
                    </MenuItem>
                  ))}
              </TextField>
              <TextField select size="small" label="Prismodell" sx={{ width: 190, flexShrink: 0 }}
                value={form.prismodell}
                onChange={e => setForm(f => ({ ...f, prismodell: e.target.value }))}>
                <MenuItem value="">– Välj –</MenuItem>
                {PRISMODELL.map(p => <MenuItem key={p.key} value={p.key}>{p.label}</MenuItem>)}
              </TextField>
            </Box>

            {/* Storlek – värde och sannolikhet sätts vid behov under Ekonomi på leadet */}
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
              <Typography variant="caption" color="text.secondary"
                sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                Storlek
              </Typography>
              <StorlekValjare value={form.storlek} onChange={v => setForm(f => ({ ...f, storlek: v }))} />
            </Box>

            {/* Sandbox + OfferStatus */}
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, cursor: 'pointer',
                px: 1.5, py: 0.75, borderRadius: 1, border: '1px solid',
                borderColor: form.hasSandbox ? '#FFE082' : 'divider',
                bgcolor: form.hasSandbox ? '#FFF8E1' : 'transparent',
                userSelect: 'none',
              }} onClick={() => setForm(f => ({ ...f, hasSandbox: !f.hasSandbox }))}>
                <Box sx={{ width: 14, height: 14, borderRadius: '50%', border: '2px solid #F57C00',
                  bgcolor: form.hasSandbox ? '#F57C00' : 'transparent', flexShrink: 0 }} />
                <Typography variant="caption" fontWeight={form.hasSandbox ? 700 : 400}
                  sx={{ color: form.hasSandbox ? '#E65100' : 'text.secondary', fontSize: '0.75rem' }}>
                  Sandbox-testad
                </Typography>
              </Box>
              {['proposal', 'negotiation', 'pilot', 'won'].includes(form.status) && (
                <TextField select size="small" label="Offert-status" sx={{ width: 180 }}
                  value={form.offerStatus || ''}
                  onChange={e => setForm(f => ({ ...f, offerStatus: e.target.value }))}>
                  <MenuItem value="">– Ej satt –</MenuItem>
                  {OFFER_STATUSES.map(o => <MenuItem key={o.key} value={o.key}>{o.label}</MenuItem>)}
                </TextField>
              )}
              {['demo', 'sandbox'].includes(form.status) && (
                <TextField select size="small" label="Demo-status" sx={{ width: 180 }}
                  value={form.demoStatus || ''}
                  onChange={e => setForm(f => ({ ...f, demoStatus: e.target.value }))}>
                  <MenuItem value="">– Ej satt –</MenuItem>
                  {DEMO_STATUSES.map(d => <MenuItem key={d.key} value={d.key}>{d.label}</MenuItem>)}
                </TextField>
              )}
            </Box>

            {/* Samarbetestagg */}
            {PARTNERSHIP_TAGS.length > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Samarbete
                </Typography>
                {PARTNERSHIP_TAGS.map(t => {
                  const sel = (form.tags || []).includes(t.key);
                  return (
                    <Chip key={t.key} label={t.key} size="small"
                      onClick={() => setForm(f => {
                        const cur = f.tags || [];
                        return { ...f, tags: sel ? cur.filter(k => k !== t.key) : [...cur, t.key] };
                      })}
                      sx={{ cursor: 'pointer', fontWeight: sel ? 700 : 400,
                        bgcolor: sel ? t.bg : 'transparent',
                        color: sel ? t.color : 'text.secondary',
                        border: `1px solid ${sel ? t.color : '#ccc'}` }} />
                  );
                })}
              </Box>
            )}

            {/* Rad: Nästa uppföljning + Förväntat avslut */}
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <TextField size="small" label="Nästa uppföljning" type="date"
                InputLabelProps={{ shrink: true }} sx={{ flex: 1 }}
                value={form.nextFollowUp}
                onChange={e => setForm(f => ({ ...f, nextFollowUp: e.target.value }))} />
              <TextField size="small" label="Förväntat avslut" type="date"
                InputLabelProps={{ shrink: true }} sx={{ flex: 1 }}
                value={form.expectedCloseDate}
                onChange={e => setForm(f => ({ ...f, expectedCloseDate: e.target.value }))} />
            </Box>

            {/* Rad: Driftsättning + Plan + [Kontrakttill om vunnen] */}
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
              <TextField select size="small" label="Driftsättning" sx={{ width: 200, flexShrink: 0 }}
                value={form.deploymentType}
                onChange={e => setForm(f => ({ ...f, deploymentType: e.target.value }))}>
                <MenuItem value="">– Välj –</MenuItem>
                {deploymentTypes.map(d => <MenuItem key={d.key} value={d.key}>{d.label}</MenuItem>)}
              </TextField>
              <FormControl size="small" sx={{ flex: 1, minWidth: 160 }}>
                <InputLabel>Plan / Licenstyp</InputLabel>
                <Select
                  multiple
                  value={Array.isArray(form.plan) ? form.plan : (form.plan ? [form.plan] : [])}
                  onChange={e => setForm(f => ({ ...f, plan: e.target.value }))}
                  input={<OutlinedInput label="Plan / Licenstyp" />}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(val => {
                        const p = plans.find(p => p.key === val);
                        return <Chip key={val} label={p?.label || val} size="small" />;
                      })}
                    </Box>
                  )}
                >
                  {plans.map(p => <MenuItem key={p.key} value={p.key}>{p.label}</MenuItem>)}
                </Select>
              </FormControl>
              {form.status === 'won' && (
                <TextField select size="small" label="Kontrakt till (månad)" sx={{ width: 200, flexShrink: 0 }}
                  value={form.contractEndMonth}
                  onChange={e => setForm(f => ({ ...f, contractEndMonth: e.target.value }))}>
                  <MenuItem value="">– Välj –</MenuItem>
                  {MONTHS_SV.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
                </TextField>
              )}
            </Box>

            {/* Rad: Kommun + Produkt (om produkt/kombination) */}
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
              <Autocomplete
                freeSolo size="small"
                options={SWEDISH_MUNICIPALITIES}
                value={form.municipality}
                onChange={(_, v) => setForm(f => ({ ...f, municipality: v || '' }))}
                onInputChange={(_, v) => setForm(f => ({ ...f, municipality: v }))}
                sx={{ width: 200 }}
                renderInput={params => <TextField {...params} label="Kommun" placeholder="t.ex. Göteborg" />}
              />
              {(form.type === 'produkt' || form.type === 'kombination') && (
                <TextField select size="small" label="Produkt" sx={{ flex: 1, minWidth: 180 }}
                  value={form.productId}
                  onChange={e => setForm(f => ({ ...f, productId: e.target.value }))}>
                  <MenuItem value="">– Välj produkt –</MenuItem>
                  {products.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
                </TextField>
              )}
            </Box>

            {/* Beskrivning */}
            {(() => {
              const descRef = React.createRef();
              return (
                <Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.25 }}>
                    <Tooltip title="Infoga punkt (•)">
                      <IconButton size="small" sx={{ fontSize: '0.75rem', px: 0.75, py: 0.25, borderRadius: 1,
                        color: 'text.secondary', '&:hover': { color: '#FF6B00' } }}
                        onClick={() => insertBullet(descRef, form.description, v => setForm(f => ({ ...f, description: v })))}>
                        • Lista
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <TextField ref={descRef} fullWidth size="small" label="Beskrivning / Bakgrund" multiline rows={3}
                    placeholder="Beskriv möjligheten, bakgrunden och vad kunden behöver..."
                    value={form.description}
                    onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
                </Box>
              );
            })()}

            {/* Affärsområden */}
            <Box>
              <Typography variant="caption" color="text.secondary" fontWeight="bold"
                sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1 }}>
                Affärsområden
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8 }}>
                {departments.map(d => {
                  const sel = (form.departmentIds || []).includes(d.id);
                  return (
                    <Tooltip key={d.id} title={d.name}>
                      <Chip label={deptCode(d)} size="small"
                        onClick={() => setForm(f => ({
                          ...f,
                          departmentIds: sel
                            ? f.departmentIds.filter(id => id !== d.id)
                            : [...(f.departmentIds || []), d.id]
                        }))}
                        variant={sel ? 'filled' : 'outlined'}
                        sx={{ bgcolor: sel ? '#1a1a1a' : 'transparent',
                          color: sel ? 'white' : 'text.primary', cursor: 'pointer' }} />
                    </Tooltip>
                  );
                })}
              </Box>
            </Box>

          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2.5 }}>
          <Button onClick={() => setDialog(false)} size="large">Avbryt</Button>
          <Button variant="contained" onClick={handleSave} size="large"
            disabled={saving || !form.title.trim()}
            sx={{ bgcolor: '#FF6B00', '&:hover': { bgcolor: '#e55a00' }, px: 4 }}>
            {saving ? 'Sparar...' : 'Skapa lead'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ny kund – samma dialog som i Kunder-listan */}
      {newCompanyDialog && (
        <NyKundDialog open companies={companies} departments={departments} uid={currentUser.uid}
          onClose={() => setNewCompanyDialog(false)} onSparad={nyKundSparad} />
      )}

      {/* Import-dialog */}
      <ImportDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
        companies={companies}
        products={products}
        departments={departments}
        currentUser={currentUser}
        onImported={() => { setImportOpen(false); load(); }}
      />

      {/* Inställningar – licenstyp & driftsättning */}
      <OptionsSettingsDialog
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        deploymentTypes={deploymentTypes}
        plans={plans}
        onSaved={(dt, pl) => { setDeploymentTypes(dt); setPlans(pl); }}
      />
    </Box>
  );
}

/* ─── Helpers ────────────────────────────────────────────────────────────── */
function userPhoto(u) {
  return u?.photoURL || u?.photoUrl || u?.photo || '';
}

function relativeDate(val) {
  if (!val) return '';
  let d;
  if (val?.toDate) d = val.toDate();
  else if (val?.seconds) d = new Date(val.seconds * 1000);
  else if (typeof val === 'string') d = new Date(val);
  else if (val instanceof Date) d = val;
  else return '';
  const diffDays = Math.floor((Date.now() - d) / 86400000);
  if (diffDays === 0) return 'idag';
  if (diffDays === 1) return 'igår';
  if (diffDays < 7) return `${diffDays} d`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} v`;
  return `${Math.floor(diffDays / 30)} mån`;
}

/* ─── Kanban ─────────────────────────────────────────────────────────────── */
function planDriftLabel(lead, plans, deploymentTypes) {
  const planLabels = (lead.plan || [])
    .map(k => plans.find(p => p.key === k)?.label)
    .filter(Boolean);
  const driftLabel = deploymentTypes.find(d => d.key === lead.deploymentType)?.label || '';
  // Shorten common labels for chips
  const shorten = s => s.replace('Online (SaaS)', 'SaaS').replace('On-premise', 'On-prem').replace(' + ', '+');
  const parts = [...planLabels.map(shorten), driftLabel ? shorten(driftLabel) : ''].filter(Boolean);
  return parts.join(' / ');
}

const DAGAR_TON_FARG = { neutral: 'text.disabled', orange: '#E65100', rod: '#C62828' };

// Kanbankortets rader: pills radbryts som helhet (aldrig inuti) och kortet
// blir högre i stället för att flöda över.
const PILL = { whiteSpace: 'nowrap', flexShrink: 0 };
const KORT_RAD = { display: 'flex', flexWrap: 'wrap', gap: '4px 6px', minWidth: 0, '& > *': PILL };
// Ikongruppen (stjärna, duplicera, redigera) i kortets övre högra hörn,
// 3 × 19 px. Titelns första rad håller undan med KORT_IKONER_PR (gruppen minus
// kortets högra padding på 16 px), så att texten aldrig hamnar under ikonerna;
// följande rader får hela bredden.
const KORT_IKONER_KANT = 4;
const KORT_IKON = { p: '2px', color: '#9e9e9e', '& svg': { display: 'block' } };
const KORT_IKONER_PR = 3 * 19 + KORT_IKONER_KANT - 16;

/** Nästa steg + datum på kortet, eller "Inget nästa steg". Bara för aktiva leads. */
function NastaSteg({ lead, idag }) {
  if (arForfallen(lead, idag)) return null; // Förfallen-chippet säger redan det
  if (!harFramtidaSteg(lead, idag)) {
    return (
      <Typography variant="caption" sx={{ display: 'block', color: '#F57C00', fontWeight: 700, fontSize: '0.68rem', mb: 0.5 }}>
        Inget nästa steg
      </Typography>
    );
  }
  const arIdag = lead.nextFollowUp === idag;
  const vad = lead.nastaSteg || (lead.demoStatus === 'bokad' && lead.nextFollowUpTime ? 'Möte' : 'Uppföljning');
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5, minWidth: 0 }}>
      <EventIcon sx={{ fontSize: 12, color: arIdag ? '#E65100' : 'text.secondary', flexShrink: 0 }} />
      <Typography variant="caption" noWrap
        sx={{ fontSize: '0.68rem', color: arIdag ? '#E65100' : 'text.secondary', fontWeight: arIdag ? 700 : 500 }}>
        {vad} · {arIdag ? 'idag' : lead.nextFollowUp}{lead.nextFollowUpTime ? ` ${lead.nextFollowUpTime}` : ''}
        {uppfoljningStatusText(lead) ? ` · ${uppfoljningStatusText(lead)}` : ''}
      </Typography>
    </Box>
  );
}

function KanbanView({ leads, companies, departments, users, products, navigate, openNew, onStatusChange, onToggleStar, onToggleSandbox, onCycleOfferStatus, onCycleDemoStatus, onDuplicate, compact, hiddenStages, toggleStage, plans, deploymentTypes, offerterMap = {}, kpMap = {}, flatboxEtiketter = {} }) {
  const [dragId, setDragId] = useState(null);
  const [dragOver, setDragOver] = useState(null);
  const idag = lokalDatum();
  const nu = Date.now();

  const visibleStages = KANBAN_STAGES.filter(s => !hiddenStages.includes(s.key));
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: `repeat(${visibleStages.length}, minmax(220px, 1fr))`,
      gap: 1.5, pb: 3, alignItems: 'flex-start',
    }}>
      {visibleStages.map(stage => {
        const stageLeads = leads
          .filter(l => l.status === stage.key || (stage.key === 'demo' && l.status === 'sandbox'))
          .sort((a, b) => {
            if (!!b.starred !== !!a.starred) return b.starred ? 1 : -1;
            const ta = a.updatedAt?.toDate?.() ?? (a.updatedAt instanceof Date ? a.updatedAt : new Date(0));
            const tb = b.updatedAt?.toDate?.() ?? (b.updatedAt instanceof Date ? b.updatedAt : new Date(0));
            return tb - ta;
          });
        const isDropTarget = dragOver === stage.key && dragId !== null;
        return (
          <Box key={stage.key} sx={{ minWidth: 0 }}>
            {/* Column header */}
            <Box sx={{
              bgcolor: stage.darkBg, color: 'white',
              px: 1.5, py: 1, borderRadius: '8px 8px 0 0',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flex: 1, minWidth: 0, overflow: 'hidden' }}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ fontSize: '0.75rem',
                  textTransform: 'uppercase', letterSpacing: 0.5, minWidth: 0 }} noWrap>
                  {stage.label}
                </Typography>
                <Box sx={{
                  bgcolor: 'rgba(255,255,255,0.25)', color: 'white',
                  borderRadius: '10px', px: 0.75, py: 0.1,
                  fontSize: '0.7rem', fontWeight: 'bold', lineHeight: 1.6,
                  flexShrink: 0,
                }}>
                  {stageLeads.length}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flexShrink: 0 }}>
                <Tooltip title={`Nytt lead i ${stage.label}`}>
                  <IconButton size="small" onClick={() => openNew(stage.key)}
                    sx={{ color: 'white', p: 0.25,
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }}>
                    <AddIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title={`Dölj ${stage.label}`}>
                  <IconButton size="small" onClick={() => toggleStage(stage.key)}
                    sx={{ color: 'rgba(255,255,255,0.6)', p: 0.25,
                      '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.2)' } }}>
                    <VisibilityOffIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            {/* Cards drop zone */}
            <Box
              onDragOver={e => { e.preventDefault(); if (dragOver !== stage.key) setDragOver(stage.key); }}
              onDragLeave={e => { if (!e.currentTarget.contains(e.relatedTarget)) setDragOver(null); }}
              onDrop={e => {
                e.preventDefault();
                if (dragId) onStatusChange(dragId, stage.key);
                setDragId(null); setDragOver(null);
              }}
              sx={{
                bgcolor: isDropTarget ? stage.color + '22' : stage.bg,
                borderRadius: '0 0 8px 8px',
                p: 1.5, minHeight: 120,
                display: 'flex', flexDirection: 'column', gap: 1.5,
                outline: isDropTarget ? `2px dashed ${stage.color}` : 'none',
                transition: 'background 0.15s',
              }}>
              {stageLeads.length === 0 ? (
                <Box sx={{
                  py: 3, textAlign: 'center',
                  border: '1.5px dashed', borderColor: stage.color + '55',
                  borderRadius: 2, cursor: 'pointer',
                  '&:hover': { borderColor: stage.color, bgcolor: 'rgba(255,255,255,0.5)' }
                }}
                  onClick={() => openNew(stage.key)}>
                  <AddIcon sx={{ fontSize: 20, color: stage.color + '88' }} />
                  <Typography variant="caption" sx={{ color: stage.color, display: 'block', mt: 0.3 }}>
                    Lägg till lead
                  </Typography>
                </Box>
              ) : stageLeads.map(lead => {
                const company = companies.find(c => c.id === lead.companyId);
                const owner = users.find(u => u.id === lead.ownerId);
                const product = products.find(p => p.id === lead.productId);
                const aktiv = arAktiv(lead);
                const followUpOverdue = aktiv && arForfallen(lead, idag);
                const needsRebooking = DEMO_NEEDS_REBOOKING.includes(lead.demoStatus);
                const isDragging = dragId === lead.id;
                const antalOfferter = (offerterMap[lead.id] || []).length;
                const dagar = aktiv ? dagarISkede(lead, nu) : null;
                const dagarTon = dagarISkedeTon(dagar);
                const lastUpdated = relativeDate(lead.updatedAt);
                const lastActivityText = lead.lastActivitySummary
                  ? `${lead.lastActivitySummary}${lead.lastActivityDate ? ` · ${lead.lastActivityDate}` : ''}`
                  : null;

                const cardContent = compact ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                    <IconButton size="small" sx={{ p: 0.2, flexShrink: 0, color: lead.starred ? '#FF6B00' : '#ddd', '&:hover': { color: '#FF6B00' } }}
                      onClick={e => { e.stopPropagation(); onToggleStar(lead.id, !!lead.starred); }}>
                      {lead.starred ? <StarIcon sx={{ fontSize: 13 }} /> : <StarBorderIcon sx={{ fontSize: 13 }} />}
                    </IconButton>
                    <Typography variant="caption" fontWeight={700} noWrap sx={{ flex: 1, lineHeight: 1.3, fontSize: '0.75rem' }}>
                      {lead.title}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, flexShrink: 0 }}>
                      {lastUpdated && (
                        <Chip label={lastUpdated} size="small"
                          sx={{ fontSize: '0.58rem', height: 14, px: 0,
                            bgcolor: lastUpdated === 'idag' ? '#E3F2FD' : 'rgba(0,0,0,0.06)',
                            color: lastUpdated === 'idag' ? '#1565C0' : 'text.disabled',
                            fontWeight: lastUpdated === 'idag' ? 700 : 400,
                          }} />
                      )}
                      <IconButton size="small" sx={{ p: 0.3, opacity: 0.4, '&:hover': { opacity: 1, color: '#FF6B00' } }}
                        onClick={e => { e.stopPropagation(); navigate(`/crm/leads/${lead.id}`); }}>
                        <EditIcon sx={{ fontSize: 12 }} />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, mb: 0.5, minWidth: 0 }}>
                        {company && (
                          <Tooltip title={company.name}>
                            <Avatar src={company.logoUrl || undefined}
                              sx={{ width: 20, height: 20, fontSize: '0.5rem', bgcolor: '#1a1a1a', flexShrink: 0, mt: 0.2 }}>
                              {!company.logoUrl && company.name?.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)}
                            </Avatar>
                          </Tooltip>
                        )}
                        <Typography variant="body2" fontWeight={700}
                          sx={{ lineHeight: 1.3, flex: 1, minWidth: 0, overflowWrap: 'break-word' }}>
                          <Box component="span" aria-hidden sx={{ float: 'right', width: KORT_IKONER_PR, height: '1em' }} />
                          {lead.title}
                        </Typography>
                    </Box>
                    {/* Ikongruppen ligger i kortets övre högra hörn och visas vid hover/fokus
                        (alltid på touch). En markerad stjärna visas alltid. */}
                    <Box sx={{ position: 'absolute', top: KORT_IKONER_KANT, right: KORT_IKONER_KANT,
                      display: 'flex', alignItems: 'center' }}>
                      <Tooltip title={lead.starred ? 'Ta bort stjärna' : 'Markera som viktig'}>
                        <IconButton size="small" className={lead.starred ? undefined : 'kort-ikon'}
                          sx={{ ...KORT_IKON, color: lead.starred ? '#FF6B00' : '#bbb', '&:hover': { color: '#FF6B00' } }}
                          onClick={e => { e.stopPropagation(); onToggleStar(lead.id, !!lead.starred); }}>
                          {lead.starred ? <StarIcon sx={{ fontSize: 15 }} /> : <StarBorderIcon sx={{ fontSize: 15 }} />}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Duplicera lead">
                        <IconButton size="small" className="kort-ikon" sx={{ ...KORT_IKON, '&:hover': { color: '#1565C0' } }}
                          onClick={e => { e.stopPropagation(); onDuplicate(lead); }}>
                          <ContentCopyIcon sx={{ fontSize: 12 }} />
                        </IconButton>
                      </Tooltip>
                      <IconButton size="small" className="kort-ikon" sx={{ ...KORT_IKON, '&:hover': { color: '#FF6B00' } }}
                        onClick={e => { e.stopPropagation(); navigate(`/crm/leads/${lead.id}`); }}>
                        <EditIcon sx={{ fontSize: 13 }} />
                      </IconButton>
                    </Box>
                    {(product || planDriftLabel(lead, plans, deploymentTypes) || lead.hasSandbox || lead.status === 'sandbox' || lead.offerStatus || (lead.tags || []).length > 0) && (
                      <Box sx={{ ...KORT_RAD, mb: 0.5 }}>
                        {product && (
                          <Chip label={product.name} size="small"
                            sx={{ ...PILL, fontSize: '0.6rem', height: 17,
                              bgcolor: '#FF6B00', color: 'white' }} />
                        )}
                        {planDriftLabel(lead, plans, deploymentTypes) && (
                          <Chip label={planDriftLabel(lead, plans, deploymentTypes)} size="small"
                            sx={{ ...PILL, fontSize: '0.6rem', height: 17,
                              bgcolor: stage.color + '22', color: stage.color }} />
                        )}
                        {(lead.hasSandbox || lead.status === 'sandbox') && (
                          <Tooltip title="Sandbox-testad — klicka för att ta bort markering">
                            <Chip label="Sandbox" size="small"
                              onClick={e => { e.stopPropagation(); onToggleSandbox(lead.id, lead); }}
                              sx={{ ...PILL, fontSize: '0.6rem', height: 17, cursor: 'pointer',
                                bgcolor: '#FFF8E1', color: '#F57C00', border: '1px solid #FFE082' }} />
                          </Tooltip>
                        )}
                        {(lead.tags || []).map(tag => {
                          const pt = PARTNERSHIP_TAGS.find(t => t.key === tag);
                          return (
                            <Chip key={tag} label={tag} size="small"
                              sx={{ ...PILL, fontSize: '0.6rem', height: 17, fontWeight: 700,
                                bgcolor: pt?.bg || '#EDE7F6', color: pt?.color || '#4527A0',
                                border: `1px solid ${pt?.color || '#4527A0'}55` }} />
                          );
                        })}
                        {(() => {
                          const isOfferStage = ['proposal', 'negotiation', 'pilot', 'won'].includes(lead.status);
                          const os = OFFER_STATUSES.find(o => o.key === lead.offerStatus);
                          if (os) {
                            return (
                              <Tooltip title="Offert-status — klicka för att byta">
                                <Chip label={`Offert ${os.label}`} size="small"
                                  onClick={e => { e.stopPropagation(); onCycleOfferStatus(lead.id, lead.offerStatus); }}
                                  sx={{ ...PILL, fontSize: '0.6rem', height: 17, cursor: 'pointer',
                                    bgcolor: os.bg, color: os.color, border: `1px solid ${os.color}55` }} />
                              </Tooltip>
                            );
                          }
                          if (isOfferStage) {
                            return (
                              <Tooltip title="Klicka för att sätta offert-status">
                                <Chip label="Offert +" size="small"
                                  onClick={e => { e.stopPropagation(); onCycleOfferStatus(lead.id, ''); }}
                                  sx={{ ...PILL, fontSize: '0.6rem', height: 17, cursor: 'pointer', fontWeight: 600,
                                    bgcolor: 'transparent', color: '#D84315', border: '1px dashed #FF6B00' }} />
                              </Tooltip>
                            );
                          }
                          return null;
                        })()}
                        {(() => {
                          const isDemoStage = lead.status === 'demo' || lead.status === 'sandbox';
                          const ds = DEMO_STATUSES.find(d => d.key === lead.demoStatus);
                          if (ds) {
                            return (
                              <Tooltip title="Demo-status — klicka för att byta">
                                <Chip label={`Demo ${ds.label}`} size="small"
                                  onClick={e => { e.stopPropagation(); onCycleDemoStatus(lead.id, lead.demoStatus); }}
                                  sx={{ ...PILL, fontSize: '0.6rem', height: 17, cursor: 'pointer',
                                    bgcolor: ds.bg, color: ds.color, border: `1px solid ${ds.color}55` }} />
                              </Tooltip>
                            );
                          }
                          if (isDemoStage) {
                            return (
                              <Tooltip title="Klicka för att sätta demo-status">
                                <Chip label="Demo +" size="small"
                                  onClick={e => { e.stopPropagation(); onCycleDemoStatus(lead.id, ''); }}
                                  sx={{ ...PILL, fontSize: '0.6rem', height: 17, cursor: 'pointer',
                                    bgcolor: 'transparent', color: '#00897B77', border: '1px dashed #00897B55' }} />
                              </Tooltip>
                            );
                          }
                          return null;
                        })()}
                      </Box>
                    )}
                    {followUpOverdue && (
                      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mb: 0.75,
                        bgcolor: '#FFEBEE', border: '1px solid #FFCDD2',
                        borderRadius: 1, px: 0.75, py: 0.25 }}>
                        <WarningAmberIcon sx={{ fontSize: 11, color: '#C62828' }} />
                        <Typography variant="caption"
                          sx={{ color: '#C62828', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.3 }}>
                          Förfallen {lead.nextFollowUp}
                        </Typography>
                      </Box>
                    )}
                    <KanbanKundprojekt kps={(lead.kundprojektIds || []).map(id => kpMap[id]).filter(Boolean)} />
                    {aktiv && <NastaSteg lead={lead} idag={idag} />}
                    {flatboxEtiketter[lead.id]?.kampanj && (
                      <Box sx={{ display: 'flex', mt: 1 }}>
                        <KampanjEtikett text={flatboxEtiketter[lead.id].kampanj} />
                      </Box>
                    )}
                    <Box sx={{ ...KORT_RAD, alignItems: 'center', mt: 1 }}>
                        <StorlekBokstav storlek={lead.storlek} />
                        {dagar != null && (
                          <Tooltip title={`${dagar} dagar i ${stage.label}`}>
                            <Typography variant="caption"
                              sx={{ ...PILL, fontSize: '0.62rem', fontWeight: dagarTon === 'neutral' ? 500 : 800,
                                color: DAGAR_TON_FARG[dagarTon] }}>
                              {dagar} d
                            </Typography>
                          </Tooltip>
                        )}
                        {antalOfferter > 0 && (
                          <Chip label={`${antalOfferter} off.`} size="small"
                            sx={{ ...PILL, fontSize: '0.58rem', height: 16, bgcolor: '#FFF3E0', color: '#E65100' }} />
                        )}
                        <SegmentEtikett segment={companies.find(c => c.id === lead.companyId)?.segment} liten />
                        <FlatboxEtikett etikett={flatboxEtiketter[lead.id]} utanKampanj />
                        {lead.activityCount > 0 && (
                          <Chip label={`${lead.activityCount} akt.`} size="small"
                            sx={{ ...PILL, fontSize: '0.58rem', height: 16,
                              bgcolor: stage.color + '22', color: stage.color }} />
                        )}
                        {lastUpdated && (
                          <Chip label={lastUpdated} size="small"
                            sx={{ ...PILL, fontSize: '0.58rem', height: 16,
                              bgcolor: lastUpdated === 'idag' ? '#E3F2FD' : 'rgba(0,0,0,0.06)',
                              color: lastUpdated === 'idag' ? '#1565C0' : 'text.disabled',
                              fontWeight: lastUpdated === 'idag' ? 700 : 400,
                            }} />
                        )}
                        {owner && (
                          <Tooltip title={owner.name || owner.email}>
                            <Avatar src={userPhoto(owner) || undefined}
                              sx={{ width: 24, height: 24, fontSize: '0.65rem', flexShrink: 0, ml: 'auto',
                                bgcolor: stage.darkBg }}
                              imgProps={{ referrerPolicy: 'no-referrer' }}>
                              {(owner.name || owner.email || '?')[0].toUpperCase()}
                            </Avatar>
                          </Tooltip>
                        )}
                    </Box>
                  </>
                );

                return (
                  <Tooltip
                    key={lead.id}
                    title={lastActivityText ? (
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.7, display: 'block', mb: 0.3 }}>
                          Senaste aktivitet
                        </Typography>
                        <Typography variant="body2">{lastActivityText}</Typography>
                      </Box>
                    ) : ''}
                    placement="right"
                    arrow
                    disableHoverListener={!lastActivityText}
                  >
                    <Paper elevation={isDragging ? 6 : 2}
                      draggable
                      onDragStart={e => { setDragId(lead.id); e.dataTransfer.effectAllowed = 'move'; }}
                      onDragEnd={() => { setDragId(null); setDragOver(null); }}
                      sx={{
                        p: compact ? 1 : 2, position: 'relative',
                        cursor: isDragging ? 'grabbing' : 'grab', borderRadius: 2,
                        '@media (hover: hover)': { '&:not(:hover):not(:focus-within) .kort-ikon': { opacity: 0 } },
                        // Ett möte som inte blev av ska synas på håll — kortet
                        // färgas tills demo-statusen bytts till en ny bokning.
                        ...(needsRebooking ? { bgcolor: '#FFF5F7', border: '1px solid #F48FB1' } : {}),
                        borderLeft: lead.starred ? '4px solid #FF6B00' : `4px solid ${stage.color}`,
                        opacity: isDragging ? 0.45 : 1,
                        transition: 'all 0.15s',
                        '&:hover': { boxShadow: 4, transform: isDragging ? 'none' : 'translateY(-1px)' }
                      }}
                      onClick={() => !dragId && navigate(`/crm/leads/${lead.id}`)}>
                      {cardContent}
                    </Paper>
                  </Tooltip>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

/* ─── OptionsSettingsDialog ──────────────────────────────────────────────── */
function OptionList({ title, items, onChange }) {
  const [newLabel, setNewLabel] = useState('');
  const [editIdx, setEditIdx] = useState(null);
  const [editLabel, setEditLabel] = useState('');

  function slugify(s) {
    return s.toLowerCase().replace(/[åä]/g, 'a').replace(/ö/g, 'o')
      .replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }

  function addItem() {
    const label = newLabel.trim();
    if (!label) return;
    const key = slugify(label) || `opt_${Date.now()}`;
    onChange([...items, { key, label }]);
    setNewLabel('');
  }

  function removeItem(i) {
    onChange(items.filter((_, idx) => idx !== i));
  }

  function startEdit(i) {
    setEditIdx(i);
    setEditLabel(items[i].label);
  }

  function saveEdit(i) {
    const label = editLabel.trim();
    if (!label) { setEditIdx(null); return; }
    const updated = items.map((it, idx) => idx === i ? { ...it, label } : it);
    onChange(updated);
    setEditIdx(null);
  }

  return (
    <Box>
      <Typography variant="caption" fontWeight="bold" color="text.secondary"
        sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1 }}>
        {items.map((it, i) => (
          <Box key={it.key} sx={{
            display: 'flex', alignItems: 'center', gap: 1,
            px: 1.5, py: 0.8, borderRadius: 1,
            border: '1px solid', borderColor: 'divider',
            bgcolor: 'background.paper',
          }}>
            <DragIndicatorIcon sx={{ fontSize: 16, color: 'text.disabled', flexShrink: 0 }} />
            {editIdx === i ? (
              <TextField
                size="small" value={editLabel} autoFocus
                onChange={e => setEditLabel(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') saveEdit(i); if (e.key === 'Escape') setEditIdx(null); }}
                sx={{ flex: 1 }}
              />
            ) : (
              <Typography variant="body2" sx={{ flex: 1 }}>{it.label}</Typography>
            )}
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              {editIdx === i ? (
                <IconButton size="small" onClick={() => saveEdit(i)}>
                  <CheckIcon sx={{ fontSize: 14, color: 'success.main' }} />
                </IconButton>
              ) : (
                <IconButton size="small" onClick={() => startEdit(i)}>
                  <EditIcon sx={{ fontSize: 14 }} />
                </IconButton>
              )}
              <IconButton size="small" onClick={() => removeItem(i)}
                sx={{ '&:hover': { color: 'error.main' } }}>
                <DeleteIcon sx={{ fontSize: 14 }} />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          size="small" placeholder={`Nytt alternativ…`}
          value={newLabel} onChange={e => setNewLabel(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && addItem()}
          sx={{ flex: 1 }}
        />
        <Button variant="outlined" size="small" onClick={addItem}
          disabled={!newLabel.trim()} startIcon={<AddIcon />}>
          Lägg till
        </Button>
      </Box>
    </Box>
  );
}

function OptionsSettingsDialog({ open, onClose, deploymentTypes, plans, onSaved }) {
  const [dt, setDt] = useState(deploymentTypes);
  const [pl, setPl] = useState(plans);
  const [saving, setSaving] = useState(false);

  // Synka när props ändras (t.ex. vid öppning)
  useEffect(() => { if (open) { setDt(deploymentTypes); setPl(plans); } }, [open, deploymentTypes, plans]);

  async function handleSave() {
    setSaving(true);
    await setDoc(doc(db, 'crmSettings', 'leadOptions'), { deploymentTypes: dt, plans: pl });
    setSaving(false);
    onSaved(dt, pl);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <TuneIcon sx={{ color: '#FF6B00', fontSize: 26 }} />
          <Box>
            <Typography variant="h6" fontWeight="bold">Alternativ för lead-formulär</Typography>
            <Typography variant="caption" color="text.secondary">
              Lägg till, redigera eller ta bort alternativ för Driftsättning och Licenstyp
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <OptionList title="Driftsättning" items={dt} onChange={setDt} />
        <Divider />
        <OptionList title="Plan / Licenstyp" items={pl} onChange={setPl} />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2.5 }}>
        <Button onClick={onClose} size="large">Avbryt</Button>
        <Button variant="contained" size="large" onClick={handleSave} disabled={saving}
          sx={{ bgcolor: '#FF6B00', '&:hover': { bgcolor: '#e55a00' }, px: 4 }}>
          {saving ? 'Sparar…' : 'Spara'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

/* ─── ProductSummary ─────────────────────────────────────────────────────── */
/* ─── ImportDialog ───────────────────────────────────────────────────────── */
function ImportDialog({ open, onClose, companies, products, departments, currentUser, onImported }) {
  const [rows, setRows]         = useState([]);   // parsed rows
  const [importing, setImporting] = useState(false);
  const [done, setDone]         = useState(false);
  const [importResult, setImportResult] = useState(null); // { created, skipped }
  const [error, setError]       = useState('');
  const fileRef = useRef();

  function reset() { setRows([]); setDone(false); setImportResult(null); setError(''); }

  // Map raw cell value → deploymentType key
  function mapDeployment(v) {
    const s = (v || '').toLowerCase();
    if (s === 'onprem') return 'onprem';
    if (s === 'online') return 'online';
    return 'oklart';
  }

  function mapPlan(v) {
    const s = (v || '').toLowerCase();
    if (s.includes('enterprise') && s.includes('projekt')) return 'enterprise_projekt';
    if (s.includes('enterprise')) return 'enterprise';
    if (s.includes('projekt')) return 'projekt';
    return '';
  }

  function mapUnit(v) {
    const s = (v || '').toLowerCase();
    if (s === 'projekt') return 'projekt';
    if (s === 'månad' || s === 'manad') return 'manad';
    return 'ar';
  }

  function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    setError('');
    const reader = new FileReader();
    reader.onload = ev => {
      try {
        const wb = XLSX.read(ev.target.result, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

        // Hitta sektioner: "Befintliga affärer" och "Leads"
        const parsed = [];
        let section = null;
        data.forEach(row => {
          const first = String(row[0] || '').trim();
          if (first === 'Befintliga affärer') { section = 'won'; return; }
          if (first === 'Leads') { section = 'leads'; return; }
          if (first === 'Kund' || first === 'Summa:' || first === '') return;
          if (!section || !first) return;

          const [kund, produkt, typ, plan, intakt, per, , kontraktTill, kommentar] = row;
          if (!kund) return;

          parsed.push({
            customerName:    String(kund).trim(),
            productName:     String(produkt || '').trim(),
            deploymentType:  mapDeployment(typ),
            plan:            [mapPlan(plan)].filter(Boolean),
            estimatedValue:  parseFloat(String(intakt || '0').replace(',', '.')) || 0,
            revenueUnit:     mapUnit(per),
            contractEndMonth: section === 'won' ? String(kontraktTill || '').trim() : '',
            description:     String(kommentar || '').trim(),
            status:          section === 'won' ? 'won' : 'identified',
            type:            'produkt',
          });
        });
        setRows(parsed);
      } catch (err) {
        setError('Kunde inte läsa filen: ' + err.message);
      }
    };
    reader.readAsArrayBuffer(file);
  }

  async function handleImport() {
    setImporting(true);
    const { addDoc, collection, getDocs } = await import('firebase/firestore');
    const { db } = await import('../firebase/config');

    // Hämta befintliga leads för att undvika dubbletter
    const existingSnap = await getDocs(collection(db, 'crmLeads'));
    const existingTitles = new Set(existingSnap.docs.map(d => (d.data().title || '').toLowerCase()));

    // Bygg upp company-map (name → id)
    const compMap = {};
    companies.forEach(c => { compMap[c.name.toLowerCase()] = c.id; });

    // Bygg produkt-map (name → id)
    const prodMap = {};
    products.forEach(p => { prodMap[p.name.toLowerCase()] = p.id; });

    // MVL-avdelning
    const mvlDept = departments.find(d => d.name?.toUpperCase().includes('MVL'));

    let created = 0, skipped = 0;
    for (const row of rows) {
      const title = `${row.productName} – ${row.customerName}`;

      // Hoppa över om leadet redan finns
      if (existingTitles.has(title.toLowerCase())) {
        skipped++;
        continue;
      }

      // Skapa företag om det inte finns
      let companyId = compMap[row.customerName.toLowerCase()];
      if (!companyId) {
        const ref = await addDoc(collection(db, 'crmCompanies'), {
          name: row.customerName, status: 'prospect', createdAt: new Date(),
        });
        companyId = ref.id;
        compMap[row.customerName.toLowerCase()] = companyId;
      }

      // Matcha produkt
      const productId = prodMap[row.productName.toLowerCase()] || '';

      const leadRef = await addDoc(collection(db, 'crmLeads'), {
        title,
        companyId,
        productId,
        type: 'produkt',
        deploymentType: row.deploymentType,
        plan: row.plan,
        estimatedValue: row.estimatedValue,
        revenueUnit: row.revenueUnit,
        contractEndMonth: row.contractEndMonth,
        description: row.description,
        status: row.status,
        ...nyttLeadSkedesfalt(row.status, currentUser.uid),
        departmentIds: mvlDept ? [mvlDept.id] : [],
        ownerId: currentUser.uid,
        createdBy: currentUser.uid,
        createdAt: new Date(),
        updatedAt: new Date(),
      });
      created++;

      // Lägg till kommentar som aktivitet i loggen
      if (row.description?.trim()) {
        await addDoc(collection(db, 'crmLeads', leadRef.id, 'activities'), {
          type: 'note',
          summary: row.description.trim(),
          date: new Date().toISOString().split('T')[0],
          createdBy: currentUser.uid,
          createdAt: new Date(),
        });
      }
    }
    setImporting(false);
    setImportResult({ created, skipped });
    setDone(true);
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <UploadFileIcon sx={{ color: '#FF6B00', fontSize: 28 }} />
          <Box>
            <Typography variant="h6" fontWeight="bold">Importera leads</Typography>
            <Typography variant="caption" color="text.secondary">
              Excel (.xlsx) eller CSV – kolumner: Kund, Produkt, Typ, Plan, Intäkt KSEK, Per, Löptid, Kontrakt till, Kommentar
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2.5 }}>
        {done ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>✅</Typography>
            <Typography fontWeight="bold">{importResult?.created ?? 0} leads importerade!</Typography>
            {importResult?.skipped > 0 && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {importResult.skipped} hoppades över (finns redan i systemet)
              </Typography>
            )}
          </Box>
        ) : (
          <>
            <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button variant="outlined" startIcon={<UploadFileIcon />}
                onClick={() => { reset(); fileRef.current?.click(); }}>
                Välj fil (.xlsx / .csv)
              </Button>
              <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv" style={{ display: 'none' }}
                onChange={handleFile} />
              {rows.length > 0 && (
                <Typography variant="body2" color="text.secondary">
                  {rows.length} rader inlästa
                </Typography>
              )}
            </Box>
            {error && <Typography color="error" variant="body2" sx={{ mb: 1 }}>{error}</Typography>}
            {rows.length > 0 && (
              <Box sx={{ overflowX: 'auto', maxHeight: 320, overflow: 'auto' }}>
                <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.78rem' }}>
                  <Box component="thead">
                    <Box component="tr" sx={{ bgcolor: '#f5f5f5' }}>
                      {['Status','Kund','Produkt','Typ','Plan','Intäkt KSEK','Enhet','Kommentar'].map(h => (
                        <Box key={h} component="th" sx={{ px: 1.5, py: 0.8, textAlign: 'left', fontWeight: 700, borderBottom: '1px solid #ddd', whiteSpace: 'nowrap' }}>{h}</Box>
                      ))}
                    </Box>
                  </Box>
                  <Box component="tbody">
                    {rows.map((r, i) => (
                      <Box key={i} component="tr" sx={{ borderBottom: '1px solid #eee', '&:hover': { bgcolor: '#fafafa' } }}>
                        <Box component="td" sx={{ px: 1.5, py: 0.6 }}>
                          <Chip label={r.status === 'won' ? 'Kund' : 'Lead'} size="small"
                            sx={{ height: 18, fontSize: '0.65rem',
                              bgcolor: r.status === 'won' ? '#E8F5E9' : '#FFF3E0',
                              color: r.status === 'won' ? '#2E7D32' : '#FF6B00' }} />
                        </Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6, fontWeight: 600 }}>{r.customerName}</Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6 }}>{r.productName}</Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6 }}>{r.deploymentType}</Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6 }}>{Array.isArray(r.plan) ? r.plan.join(', ') : r.plan}</Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6, fontWeight: 700, color: '#FF6B00' }}>{r.estimatedValue || '–'}</Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6 }}>{r.revenueUnit}</Box>
                        <Box component="td" sx={{ px: 1.5, py: 0.6, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.description}</Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2.5 }}>
        <Button onClick={onClose} size="large">{done ? 'Stäng' : 'Avbryt'}</Button>
        {!done && rows.length > 0 && (
          <Button variant="contained" size="large" onClick={handleImport}
            disabled={importing}
            sx={{ bgcolor: '#FF6B00', '&:hover': { bgcolor: '#e55a00' }, px: 4 }}>
            {importing ? `Importerar (${rows.length})…` : `Importera ${rows.length} leads`}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

/* ─── Calendar view ─────────────────────────────────────────────────────── */

const TODAY = new Date().toISOString().split('T')[0];

function calColor(dateStr, type) {
  // type: 'followup' | 'close'
  if (!dateStr) return null;
  const isPast  = dateStr < TODAY;
  const isToday = dateStr === TODAY;
  if (isPast)  return type === 'followup' ? '#DC2626' : '#9C27B0'; // röd / lila
  if (isToday) return '#F97316';                                    // orange
  return type === 'followup' ? '#1565C0' : '#2E7D32';              // blå / grön
}

function CalendarView({ leads, companies, users, navigate }) {
  const now = new Date();
  const [year, setYear]   = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth()); // 0-based

  function prevMonth() {
    if (month === 0) { setMonth(11); setYear(y => y - 1); }
    else setMonth(m => m - 1);
  }
  function nextMonth() {
    if (month === 11) { setMonth(0); setYear(y => y + 1); }
    else setMonth(m => m + 1);
  }

  // Bygger en map: 'YYYY-MM-DD' → [{lead, type}]
  const eventMap = {};
  leads.forEach(lead => {
    [
      { date: lead.nextFollowUp,     type: 'followup' },
      { date: lead.expectedCloseDate, type: 'close' },
    ].forEach(({ date, type }) => {
      if (!date) return;
      if (!eventMap[date]) eventMap[date] = [];
      eventMap[date].push({ lead, type });
    });
  });

  // Kalender-rutnät
  const firstDay = new Date(year, month, 1).getDay(); // 0=sön
  const startOffset = (firstDay + 6) % 7;             // måndag=0
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const monthNames = ['Januari','Februari','Mars','April','Maj','Juni',
    'Juli','Augusti','September','Oktober','November','December'];
  const dayNames = ['Mån','Tis','Ons','Tor','Fre','Lör','Sön'];

  return (
    <Box>
      {/* Förklaring */}
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2, alignItems: 'center' }}>
        {[
          { color: '#DC2626', icon: <EventIcon sx={{ fontSize: 14 }} />, label: 'Missad uppföljning' },
          { color: '#F97316', icon: <EventIcon sx={{ fontSize: 14 }} />, label: 'Uppföljning idag' },
          { color: '#1565C0', icon: <EventIcon sx={{ fontSize: 14 }} />, label: 'Kommande uppföljning' },
          { color: '#9C27B0', icon: <FlagIcon sx={{ fontSize: 14 }} />,  label: 'Missat avslutsdatum' },
          { color: '#2E7D32', icon: <FlagIcon sx={{ fontSize: 14 }} />,  label: 'Förväntat avslut' },
        ].map(({ color, icon, label }) => (
          <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ color, display: 'flex' }}>{icon}</Box>
            <Typography variant="caption" color="text.secondary">{label}</Typography>
          </Box>
        ))}
      </Box>

      <Paper sx={{ overflow: 'hidden' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          px: 3, py: 2, bgcolor: '#1a1a1a', color: 'white' }}>
          <IconButton onClick={prevMonth} sx={{ color: 'white' }} size="small">
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="h6" fontWeight="bold">
            {monthNames[month]} {year}
          </Typography>
          <IconButton onClick={nextMonth} sx={{ color: 'white' }} size="small">
            <ChevronRightIcon />
          </IconButton>
        </Box>

        {/* Veckodagsrubriker */}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)',
          bgcolor: '#f5f5f5', borderBottom: '1px solid', borderColor: 'divider' }}>
          {dayNames.map(d => (
            <Box key={d} sx={{ py: 1, textAlign: 'center' }}>
              <Typography variant="caption" fontWeight="bold" color="text.secondary">
                {d}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Dagar */}
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' }}>
          {cells.map((day, i) => {
            const dateStr = day
              ? `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
              : null;
            const isToday = dateStr === TODAY;
            const events = dateStr ? (eventMap[dateStr] || []) : [];
            const isWeekend = i % 7 >= 5;

            return (
              <Box key={i} sx={{
                minHeight: 90,
                p: 0.75,
                borderRight: '1px solid', borderBottom: '1px solid',
                borderColor: 'divider',
                bgcolor: !day ? '#fafafa' : isToday ? '#fff8f0' : isWeekend ? '#fcfcfc' : 'background.paper',
              }}>
                {day && (
                  <>
                    <Typography variant="caption" fontWeight={isToday ? 900 : 400}
                      sx={{
                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                        width: 22, height: 22, borderRadius: '50%',
                        bgcolor: isToday ? '#FF6B00' : 'transparent',
                        color: isToday ? 'white' : 'text.primary',
                        mb: 0.4,
                      }}>
                      {day}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      {events.map(({ lead, type }, ei) => {
                        const color = calColor(dateStr, type);
                        const company = companies.find(c => c.id === lead.companyId);
                        const isFollowup = type === 'followup';
                        return (
                          <Tooltip key={ei} arrow title={
                            <Box>
                              <Typography variant="caption" fontWeight="bold">{lead.title}</Typography>
                              {company && <Typography variant="caption" display="block" sx={{ opacity: 0.8 }}>{company.name}</Typography>}
                              <Typography variant="caption" display="block" sx={{ opacity: 0.7 }}>
                                {isFollowup ? '📅 Uppföljning' : '🏁 Förväntat avslut'}
                              </Typography>
                            </Box>
                          }>
                            <Box
                              onClick={() => navigate(`/crm/leads/${lead.id}`)}
                              sx={{
                                display: 'flex', alignItems: 'center', gap: 0.4,
                                bgcolor: color + '18',
                                borderLeft: `3px solid ${color}`,
                                borderRadius: '0 3px 3px 0',
                                px: 0.5, py: 0.2,
                                cursor: 'pointer',
                                '&:hover': { bgcolor: color + '30' },
                              }}>
                              <Box sx={{ color, display: 'flex', flexShrink: 0 }}>
                                {isFollowup
                                  ? <EventIcon sx={{ fontSize: 10 }} />
                                  : <FlagIcon sx={{ fontSize: 10 }} />}
                              </Box>
                              <Typography sx={{
                                fontSize: '0.65rem', lineHeight: 1.2,
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                                color, fontWeight: 600,
                              }}>
                                {lead.title}
                              </Typography>
                            </Box>
                          </Tooltip>
                        );
                      })}
                    </Box>
                  </>
                )}
              </Box>
            );
          })}
        </Box>
      </Paper>
    </Box>
  );
}

/* ─── List view ──────────────────────────────────────────────────────────── */
// Flatbox-leadets etikett: antal kopplade offerter, eller "Signerad" (framhävd).
// Pilot/kampanj med leveransdatum: "Pilot t.o.m. …" (eller "Kampanj t.o.m. …").
function FlatboxEtikett({ etikett, liten, utanKampanj }) {
  if (!etikett) return null;
  return (
    <>
      <Chip label={etikett.text} size="small" data-testid="flatbox-etikett"
        sx={{ ...PILL, fontSize: liten ? '0.6rem' : '0.58rem', height: 16,
          bgcolor: etikett.signerad ? '#2E7D32' : '#FDECEC',
          color: etikett.signerad ? '#fff' : '#B71C1C',
          fontWeight: etikett.signerad ? 800 : 600 }} />
      {etikett.kampanj && !utanKampanj && <KampanjEtikett text={etikett.kampanj} liten={liten} />}
    </>
  );
}

function KampanjEtikett({ text, liten }) {
  return (
    <Chip label={text} size="small" data-testid="kampanj-etikett"
      sx={{ ...PILL, fontSize: liten ? '0.6rem' : '0.58rem', height: 16, bgcolor: '#E8EAF6', color: '#3949AB', fontWeight: 700 }} />
  );
}

function ListView({ leads, companies, departments, users, products, navigate, hiddenCols = [], offerterMap = {}, flatboxEtiketter = {} }) {
  const show = key => !hiddenCols.includes(key);

  if (leads.length === 0) return (
    <Paper sx={{ p: 6, textAlign: 'center' }}>
      <TrendingUpIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
      <Typography color="text.secondary">Inga leads matchar filtret.</Typography>
    </Paper>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {leads.map(lead => {
        const st = stageInfo(lead.status);
        const company = companies.find(c => c.id === lead.companyId);
        const owner = users.find(u => u.id === lead.ownerId);
        const product = products.find(p => p.id === lead.productId);
        const leadDepts = departments.filter(d => (lead.departmentIds || []).includes(d.id));
        const followUpOverdue = isOverdue(lead.nextFollowUp);
        const followUpToday = isDueToday(lead.nextFollowUp);
        const needsRebooking = DEMO_NEEDS_REBOOKING.includes(lead.demoStatus);
        return (
          <Paper key={lead.id} sx={{
            p: 2.5, cursor: 'pointer',
            borderLeft: `5px solid ${st.color}`,
            bgcolor: needsRebooking ? '#FFF5F7' : followUpOverdue ? '#fff5f5' : 'white',
            '&:hover': { boxShadow: 3 },
            display: 'flex', alignItems: 'center', gap: 2
          }}
            onClick={() => navigate(`/crm/leads/${lead.id}`)}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3, flexWrap: 'wrap' }}>
                <Typography fontWeight={600} noWrap>{lead.title}</Typography>
                {show('product') && product && (
                  <Chip label={product.name} size="small"
                    sx={{ fontSize: '0.6rem', height: 18, bgcolor: '#FF6B00', color: 'white' }} />
                )}
                {show('product') && !product && lead.type && (
                  <Chip label={BASE_TYPES.find(t => t.key === lead.type)?.label || lead.type}
                    size="small" sx={{ fontSize: '0.6rem', height: 18, bgcolor: '#f5f5f5' }} />
                )}
                {show('depts') && leadDepts.map(d => (
                  <Tooltip key={d.id} title={d.name}>
                    <Chip label={deptCode(d)} size="small"
                      sx={{ fontSize: '0.6rem', height: 18, bgcolor: '#1a1a1a', color: 'white' }} />
                  </Tooltip>
                ))}
                {needsRebooking && (() => {
                  const ds = DEMO_STATUSES.find(d => d.key === lead.demoStatus);
                  return (
                    <Chip label={`Demo ${ds.label} — boka ny tid`} size="small"
                      sx={{ fontSize: '0.6rem', height: 18, fontWeight: 700,
                        bgcolor: ds.bg, color: ds.color, border: `1px solid ${ds.color}55` }} />
                  );
                })()}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                {show('company') && company && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Avatar src={company.logoUrl || undefined}
                      sx={{ width: 18, height: 18, fontSize: '0.48rem', bgcolor: '#1a1a1a', flexShrink: 0 }}>
                      {!company.logoUrl && company.name?.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)}
                    </Avatar>
                    <Typography variant="caption" color="text.secondary">{company.name}</Typography>
                  </Box>
                )}
                {show('owner') && owner && (
                  <Tooltip title={owner.displayName || owner.name || owner.email}>
                    <Avatar src={userPhoto(owner) || undefined}
                      sx={{ width: 20, height: 20, fontSize: '0.55rem', bgcolor: '#546E7A' }}
                      imgProps={{ referrerPolicy: 'no-referrer' }}>
                      {(owner.displayName || owner.name || owner.email || '?')[0].toUpperCase()}
                    </Avatar>
                  </Tooltip>
                )}
                {show('followup') && (followUpOverdue || followUpToday) && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                    <WarningAmberIcon sx={{ fontSize: 12,
                      color: followUpOverdue ? '#C62828' : '#F57C00' }} />
                    <Typography variant="caption"
                      sx={{ color: followUpOverdue ? '#C62828' : '#F57C00', fontWeight: 600 }}>
                      {followUpOverdue ? 'Förfallen' : 'Uppföljning idag'}
                    </Typography>
                  </Box>
                )}
                {show('followup') && lead.expectedCloseDate && !followUpOverdue && !followUpToday && (
                  <Typography variant="caption" color="text.secondary">
                    Avslut: {lead.expectedCloseDate}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
              {show('value') && (lead.storlek || (offerterMap[lead.id] || []).length > 0 || flatboxEtiketter[lead.id]) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'flex-end' }}>
                  <StorlekBokstav storlek={lead.storlek} />
                  {(offerterMap[lead.id] || []).length > 0 && (
                    <Typography variant="caption" color="text.secondary">
                      {(offerterMap[lead.id] || []).length} off.
                    </Typography>
                  )}
                  <FlatboxEtikett etikett={flatboxEtiketter[lead.id]} liten />
                </Box>
              )}
              {show('status') && (
                <Box sx={{ mt: 0.5 }}>
                  <Chip label={st.label} size="small"
                    sx={{ fontSize: '0.65rem', height: 20,
                      bgcolor: st.bg, color: st.color, fontWeight: 600 }} />
                </Box>
              )}
            </Box>
          </Paper>
        );
      })}
    </Box>
  );
}
